import {Box} from '@chakra-ui/react';
import React, {useMemo} from 'react';

const SVG = React.memo(() => (
  <>
    <g id="world 1">
      <path
        id="Vector"
        d="M1141.38 581.344L1141.99 583.377L1141.28 586.527L1142.2 589.576L1141.28 592.016L1141.69 594.252L1129.78 594.15L1128.96 614.985L1132.63 620.27L1136.29 624.335L1125.7 626.978L1111.96 626.063L1108.09 623.014L1084.98 623.217L1084.17 623.725L1080.81 620.778L1077.15 620.575L1073.68 621.693L1070.94 622.912L1070.43 618.847L1071.34 613.054L1073.38 607.057L1073.68 604.313L1075.62 598.419L1077.04 595.776L1080.4 591.507L1082.34 588.56L1082.95 583.783L1082.64 580.023L1081.01 577.685L1079.49 573.722L1078.16 569.86L1078.47 568.437L1080.2 565.896L1078.57 559.595L1077.35 555.224L1074.5 551.057L1075.11 549.838L1077.45 548.923L1079.18 549.025L1081.22 548.313L1098.22 548.415L1099.54 553.192L1101.17 557.155L1102.49 559.29L1104.63 562.644L1108.5 562.135L1110.33 561.221L1113.49 562.135L1114.4 560.509L1115.93 556.749L1119.49 556.444L1119.8 555.326H1122.75L1122.24 557.664L1129.17 557.562L1129.27 561.729L1130.39 564.168L1129.47 568.132L1129.88 572.197L1131.71 574.636L1131.3 582.36L1132.73 581.751L1135.17 581.954L1138.73 580.938L1141.38 581.344Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M1074.3 547.805L1072.77 542.927L1075.11 540.081L1076.84 538.963L1078.98 541.199L1076.94 542.622L1075.92 544.248L1075.72 547.094L1074.3 547.805Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="AL"
        d="M1107.58 231.725L1107.99 232.944L1109.42 232.334L1110.64 234.062L1111.96 234.774L1112.57 237.111L1112.06 239.347L1113.08 242.091L1115.42 243.616L1115.52 245.343L1113.79 246.258L1113.69 248.392L1111.45 251.543L1110.54 251.137L1110.33 249.714L1107.18 247.478L1106.46 244.429L1106.57 239.957L1107.07 238.026L1106.16 237.01L1105.65 234.875L1107.58 231.725Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M681.144 865.613L678.09 865.41H673L666.892 851.588L670.047 854.434L674.425 859.109L682.365 862.869L689.797 864.394L688.982 867.443L684.503 867.748L681.144 865.613Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M650.095 655.232L661.598 665.802L666.281 666.818L673.712 671.697L679.719 674.237L680.838 677.083L676.563 687.043L682.467 688.771L688.881 689.787L693.156 688.771L697.534 683.689L697.839 677.998L700.486 676.677L703.743 680.539L704.151 685.722L699.875 689.279L696.516 691.922L691.12 698.325L685.012 707.167L684.503 712.452L684.096 719.159L685.318 725.664L684.401 727.087L684.809 731.254L685.114 734.709L693.054 740.299L693.258 744.771L697.228 747.617L697.534 750.767L694.174 759.101L687.048 762.659L676.665 763.98L670.557 763.268L672.694 767.232L672.796 772.009L674.629 775.261L672.084 777.599L666.892 778.513L661.191 776.074L659.664 777.802L662.209 784.205L666.281 786.136L668.622 784.103L671.167 787.457L666.892 789.49L663.94 793.555L665.161 799.958L665.059 803.414H660.173L657.119 806.666L657.221 811.544L663.838 816.219L669.131 817.439L669.335 823.232L664.652 826.789L664.041 834.209L660.478 836.648L659.562 839.595L663.838 846.201L668.521 849.759L666.383 849.454L661.395 848.437L649.077 847.624L645.514 843.965L643.58 839.29L640.424 839.697L637.777 837.359L634.621 830.753L637.37 827.907L637.472 823.944L635.639 820.691L636.352 815.203L635.232 806.768L633.4 803.007L635.232 801.788L633.807 799.348L630.956 798.129L631.771 795.385L628.615 792.945L624.848 785.526L626.579 784.205L623.22 776.277L622.405 769.671L622.202 763.878L624.747 761.541L621.387 755.138L619.758 749.243L622.812 744.974L621.387 739.486L623.016 733.185L621.591 727.188L619.962 725.969L614.974 714.688L617.112 707.98L615.381 701.678L616.297 695.682L618.944 689.584L622.303 685.519L620.267 682.978L621.082 680.844L619.453 669.969L625.154 666.818L626.375 660.009L625.459 658.383L629.531 652.488L637.166 654.114L640.933 658.789L642.562 653.504L649.077 653.809L650.095 655.232Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="AM"
        d="M1252.95 257.133L1251.12 257.336L1248.27 253.576L1248.07 252.559H1245.73L1243.79 250.832L1242.77 250.933L1240.33 249.104L1236.06 247.478L1235.95 244.327L1234.63 242.091L1241.76 241.075L1243.18 242.701L1245.42 243.819L1244.71 245.445L1247.97 247.681L1246.85 249.815L1249.49 251.543L1252.04 252.559L1252.95 257.133Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="AT"
        d="M1089.87 193.917L1089.57 194.73L1090.28 196.864L1090.07 199.507H1087.22L1088.34 200.93L1087.02 204.995L1086.1 206.113L1081.63 206.215L1079.18 207.739L1074.91 207.231L1067.47 205.503L1066.15 203.369L1061.16 204.487L1060.65 205.707L1057.5 204.792L1054.85 204.589L1052.51 203.369L1053.22 201.844L1053.02 200.726L1054.44 200.422L1057.19 202.149L1057.8 200.422L1062.28 200.726L1065.85 199.609L1068.29 199.812L1070.02 201.133L1070.43 200.015L1069.41 195.848L1071.14 195.035L1072.77 192.088L1076.64 194.222L1079.28 191.579L1081.01 191.071L1085.09 193.002L1087.43 192.697L1089.87 193.917Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        d="M1251.12 257.337L1247.25 256.422L1244 253.474L1242.77 250.934L1243.79 250.832L1245.73 252.56H1248.07L1248.27 253.576L1251.12 257.337Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_6"
        d="M1257.54 240.059L1260.08 237.416L1263.64 240.77L1267.31 245.445L1269.85 245.75L1271.79 247.478L1267.51 247.986L1267.61 253.068L1267.21 255.304L1265.48 256.828L1266.29 259.979L1264.97 260.385L1261 256.93L1262.22 253.779L1260.28 251.848L1258.35 252.356L1252.95 257.133L1252.04 252.56L1249.49 251.543L1246.85 249.816L1247.97 247.681L1244.71 245.445L1245.42 243.819L1243.18 242.701L1241.76 241.075L1242.88 239.957L1247.15 241.888L1250.1 242.193L1250.71 241.482L1247.36 237.924L1248.58 237.111L1250.1 237.315L1254.48 241.177L1256.92 241.685L1257.54 240.059Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BI"
        d="M1175.69 539.064L1175.08 539.166V538.861L1173.04 532.661L1173.03 532.6L1172.94 531.543L1171.51 528.596L1175.08 529.104L1176.81 525.344L1179.96 525.75L1180.27 528.291L1181.49 529.816V531.95L1180.07 533.271L1177.72 536.727L1175.69 539.064Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BE"
        d="M1034.8 179.993L1034.39 184.262L1033.07 184.465L1032.66 188.022L1028.18 185.075L1025.63 185.583L1022.07 182.635L1019.63 180.095L1017.39 179.993L1016.57 177.757L1020.54 176.537L1024.21 177.046L1028.79 175.724L1031.95 178.468L1034.8 179.993Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BJ"
        d="M1024.82 433.976L1024.62 436.11L1025.94 439.972L1024.82 442.614L1025.43 444.342L1022.58 448.408L1020.85 450.44L1019.73 454.506L1019.93 458.672L1019.63 469.141L1014.84 469.954L1013.42 465.482L1013.72 450.44L1012.5 449.119L1012.3 445.867L1010.26 443.631L1008.53 441.7L1009.25 438.244L1011.28 437.533L1012.4 434.687L1015.25 434.077L1016.47 432.146L1018.41 430.215H1020.44L1024.82 433.976Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BF"
        d="M1006.29 412.632L1005.78 415.783L1006.6 418.73L1009.75 422.999L1009.96 426.15L1016.57 427.674L1016.47 432.146L1015.25 434.077L1012.4 434.687L1011.28 437.533L1009.25 438.244L1004.26 438.143L1001.61 437.634L999.778 438.651L997.233 438.143L987.256 438.447L987.053 442.208L987.867 447.086L983.897 445.46L981.25 445.663L979.214 447.29L976.669 445.968L975.651 443.732L973.106 442.31L972.699 438.549L974.328 435.805L974.124 433.569L978.705 428.182L979.621 423.711L981.148 422.084L983.897 422.999L986.34 421.678L987.155 419.95L991.532 417.104L992.652 415.072L998.047 412.328L1001.2 411.413L1002.63 412.632H1006.29Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BG"
        d="M1152.99 225.22L1150.65 227.862L1149.32 232.436L1151.46 236.095L1146.78 235.282L1141.69 237.314L1141.99 240.567L1137.31 241.176L1133.34 238.839L1129.27 240.668L1125.4 240.465L1124.58 236.196L1121.73 234.062L1122.45 233.249L1121.84 232.436L1122.45 230.403L1124.28 228.371L1121.43 225.626L1120.72 223.187L1121.84 221.764L1123.67 224.407L1125.6 224L1129.67 224.915L1137.41 225.322L1139.75 223.695L1145.76 222.171L1149.83 224.509L1152.99 225.22Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BA"
        d="M1102.49 217.801L1104.43 217.699L1103.31 220.545L1106.06 223.085L1105.55 226.033L1104.43 226.338L1103.51 226.948L1101.88 228.472L1101.48 232.029L1096.59 229.59L1094.45 226.846L1092.31 225.423L1089.77 222.984L1088.45 221.053L1085.7 218.004L1086.51 215.361L1088.55 216.886L1089.57 215.463L1091.91 215.361L1096.49 216.479L1100.05 216.378L1102.49 217.801Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BY"
        d="M1162.15 165.358L1158.18 165.155L1157.36 165.765L1158.89 167.797L1160.93 171.863L1156.75 172.167L1155.43 173.59L1155.74 176.741L1153.6 176.131L1149.22 176.436L1147.69 174.912L1145.96 176.03L1144.03 175.115L1140.06 175.013L1134.26 173.489L1129.27 172.981L1125.4 173.184L1122.96 174.81L1120.61 175.115L1120.11 172.269L1118.17 169.423L1121.02 168.102L1120.61 165.663L1118.88 163.325L1118.27 160.581H1123.06L1127.94 158.244L1128.45 154.788L1132.12 152.755L1131.1 150.011L1133.85 148.995L1138.53 146.657L1143.93 148.182L1144.84 149.706L1147.29 148.995L1152.17 150.418L1153.29 153.365L1152.58 154.991L1156.45 159.057L1158.59 160.175V161.293L1162.05 162.411L1163.78 164.037L1162.15 165.358Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BZ"
        d="M496.58 406.331H494.85L496.173 399.013L496.886 393.83L496.988 392.814L497.7 392.509L498.616 393.322L501.161 389.358L502.281 389.257L502.179 390.273H503.197L502.892 392.102L501.569 394.846L501.976 395.863L501.06 398.2L501.365 398.81L500.347 402.164L499.024 403.892L497.904 404.095L496.58 406.331Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BO"
        d="M674.425 641.715L674.12 639.682L668.623 636.328L663.329 636.226L653.556 638.157L651.418 643.849L651.622 647.406L650.095 655.232L649.077 653.809L642.562 653.504L640.933 658.789L637.166 654.114L629.531 652.488L625.459 658.382L621.489 659.297L618.333 650.252L614.567 642.934L615.687 636.633L612.429 633.889L611.207 629.214L607.95 624.742L610.902 617.729L607.95 612.241L609.069 610.005L607.848 607.566L609.782 604.313L609.477 598.825V594.15L610.597 592.016L604.997 581.446L609.273 582.056L612.225 581.852L613.345 579.921L618.232 577.279L621.184 574.84L628.615 573.722L628.208 578.6L629.124 581.141L628.819 585.511L635.436 591.304L641.951 592.422L644.292 594.861L648.263 596.183L650.808 598.012H654.371L657.832 599.943L658.341 603.704L659.562 605.635L659.868 608.379L658.137 608.48L660.988 616.103L671.88 616.408L671.371 620.168L672.186 622.709L675.443 624.538L677.174 628.604L676.563 633.787L675.24 636.633L676.054 640.292L674.425 641.715Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BR"
        d="M677.784 497.598L680.94 498.208L681.551 496.785L680.533 495.565L681.144 493.634L683.485 494.244L686.234 493.533L689.491 494.955L692.036 496.277L693.767 494.549L695.09 494.752L695.905 496.582L698.653 496.175L700.893 493.634L702.725 488.857L706.187 482.861L708.223 482.556L709.546 486.215L712.6 497.598L715.756 498.716L715.858 503.188L711.48 508.574L713.211 510.505L723.493 511.522L723.696 518.128L728.074 513.859L735.301 516.197L744.972 520.161L747.823 523.921L746.907 527.58L753.625 525.547L764.823 529.003L773.476 528.799L782.028 534.186L789.561 541.504L794.04 543.333L798.926 543.638L801.064 545.671L803.1 554.005L804.22 557.968L802.082 568.741L799.334 573.01L791.495 582.055L788.034 589.475L783.962 595.065L782.537 595.268L781.213 600.045L782.129 612.241L781.01 622.302L780.704 626.571L779.075 629.213L778.566 637.954L773.273 646.39L772.764 653.199L768.386 655.943L767.267 659.907H761.159L752.506 662.346L748.739 665.293L742.631 667.224L736.421 672.408L732.247 678.912L731.942 683.791L733.265 687.348L732.96 693.954L732.146 697.105L728.684 700.764L724.103 712.248L720.031 717.33L716.774 720.48L715.247 726.68L712.295 730.339L710.157 726.68L711.989 723.529L708.121 719.159L703.234 715.5L696.821 711.333L694.887 711.537L688.473 706.455L685.012 707.166L691.12 698.324L696.516 691.921L699.875 689.279L704.151 685.722L703.743 680.538L700.486 676.676L697.839 677.998L698.552 674.237L698.857 670.375L698.552 666.716L696.414 665.598L694.378 666.615L692.24 666.31L691.426 663.871L690.306 657.874L689.084 655.943L685.114 654.114L682.874 655.435L676.868 654.114L676.461 645.272L674.425 641.714L676.054 640.292L675.239 636.633L676.563 633.787L677.174 628.604L675.443 624.538L672.185 622.709L671.371 620.168L671.88 616.408L660.987 616.103L658.137 608.48L659.868 608.379L659.562 605.634L658.341 603.703L657.832 599.943L654.37 598.012H650.807L648.262 596.183L644.292 594.861L641.951 592.422L635.436 591.304L628.819 585.511L629.124 581.141L628.208 578.6L628.615 573.722L621.184 574.839L618.231 577.279L613.345 579.921L612.225 581.852L609.273 582.055L604.997 581.446L601.74 582.564L599.093 581.852L598.991 571.994L594.512 575.754L589.422 575.653L587.081 572.095L583.212 571.79L584.23 568.945L580.871 564.981L578.224 559.086L579.751 557.968L579.547 555.123L583.009 553.293L582.296 549.736L583.721 547.5L584.027 544.451L590.44 539.979L595.123 538.76L595.937 537.743L601.129 538.048L603.369 520.161L603.47 517.315L602.554 513.656L599.907 511.217L600.009 506.44L603.267 505.424L604.387 506.135L604.59 503.594L601.231 502.883V498.818L612.429 499.021L614.363 496.683L615.992 498.818L617.01 502.68L618.13 501.867L621.285 505.322L625.765 504.916L626.884 502.883L631.16 501.358L633.603 500.24L634.316 497.496L638.49 495.667L638.184 494.244L633.298 493.736L632.585 489.569L632.891 485.199L630.346 483.573L631.465 482.963L635.639 483.776L640.22 485.402L641.951 483.877L646.125 482.861L652.64 480.422L654.778 477.881L654.065 476.052L657.119 475.848L658.341 477.271L657.526 480.219L659.562 481.133L660.784 484.182L659.155 486.52L658.137 492.008L659.562 495.362L659.868 498.411L663.431 501.46L666.281 501.765L666.892 500.444L668.724 500.139L671.371 499.021L673.203 497.293L676.461 497.903L677.784 497.598Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BW"
        d="M1147.9 625.758L1149.83 630.941L1150.95 632.161L1152.58 635.921L1158.79 643.036L1161.13 643.747L1161.03 646.085L1162.56 650.252L1166.93 651.268L1170.39 654.215L1162.15 658.992L1156.86 663.871L1154.82 668.241L1152.99 670.68L1149.93 671.188L1148.71 674.339L1148.1 676.371L1144.44 677.794L1139.85 677.489L1137.31 675.66L1134.97 674.949L1132.12 676.371L1130.59 679.522L1127.84 681.453L1124.99 684.4L1120.92 685.112L1119.8 682.774L1120.41 678.811L1117.36 672.611L1115.93 671.595L1116.54 652.589L1122.14 652.386L1122.96 629.112L1127.23 628.909L1136.09 626.571L1138.12 629.315L1141.89 626.774H1143.62L1146.88 625.25L1147.9 625.758Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="CF"
        d="M1141.48 453.794L1145.45 456.335L1148.61 458.978L1148.71 461.112L1152.68 464.466L1155.12 467.312L1156.55 471.174L1160.93 473.816L1161.84 475.849L1160.01 476.56L1156.24 476.459L1151.97 475.747L1149.83 476.255L1148.91 477.881L1147.08 478.085L1144.84 476.662L1138.43 479.914L1135.78 479.304L1134.97 479.812L1133.34 483.776L1128.96 482.455L1124.79 481.845L1121.12 479.406L1116.34 477.17L1113.28 479.304L1111.05 482.557L1110.54 487.13L1106.87 486.825L1102.9 485.707L1099.54 489.163L1096.49 495.261L1095.88 493.33L1095.57 490.382L1092.92 488.248L1090.79 484.894L1090.28 482.557L1087.53 479.101L1088.04 477.17L1087.43 474.426L1087.83 469.344L1089.26 468.226L1092.11 461.62L1096.79 461.112L1097.81 459.384L1098.83 459.587L1100.25 461.01L1107.48 458.571L1109.93 456.03L1112.88 453.693L1112.27 451.457L1113.9 450.847L1119.49 451.253L1124.79 448.204L1128.86 441.09L1131.71 438.448L1135.38 437.33L1136.09 440.074L1139.45 444.139V446.883L1138.63 449.526L1139.04 451.558L1140.97 453.489L1141.48 453.794Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_7"
        d="M677.886 206.926L681.347 207.841L686.132 207.638L682.773 210.28L680.737 210.687L675.138 207.943L674.527 205.808L677.072 203.877L677.886 206.926Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_8"
        d="M692.545 190.665L690.102 190.766L684.198 188.835L680.635 185.786L682.569 185.278L688.575 186.904L692.851 189.547L692.545 190.665Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_9"
        d="M379.103 194.425L375.947 195.34L369.534 192.494V190.258L366.582 188.022L366.887 186.193L362.51 185.075L363.121 181.619L364.648 180.197L368.821 181.518L371.265 182.534L375.438 183.144L375.642 185.38L376.049 188.327L379.307 190.97L379.103 194.425Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_10"
        d="M724.307 180.705L719.217 186.193L723.187 184.058L726.139 185.481L723.696 187.616L727.565 189.343L730.415 187.819L734.792 189.75L731.942 194.425L735.81 193.307L735.505 196.661L736.014 200.625L732.349 206.316L729.906 206.52L726.954 205.3L729.499 200.117L728.277 199.304L720.846 204.792L717.792 204.588L722.271 201.539L717.792 200.015L712.193 200.421L702.42 200.218L702.216 198.389L706.085 196.051L704.354 194.425L709.851 190.563L718.199 180.501L722.475 176.944L727.565 174.81L729.702 175.013L728.175 176.741L724.307 180.705Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_11"
        d="M357.827 158.955L359.354 159.768L364.444 159.259L357.114 166.272L357.42 171.354H355.486L354.773 168.508L355.282 165.561L354.468 163.63L355.791 160.886L357.827 158.955Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_12"
        d="M646.328 110.679L642.663 113.728L640.933 113.22L640.831 111.492L641.238 111.086L644.089 109.358L645.819 109.46L646.328 110.679Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_13"
        d="M636.454 107.427L629.124 110.679L626.07 110.476V108.951L631.16 106.207L637.268 106.309L636.454 107.427Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_14"
        d="M633.298 90.3523L632.382 92.8932L635.13 91.9785L636.657 93.503L640.22 95.5357L644.089 97.2634L642.664 100.008L646.227 99.601L648.161 101.532L643.071 103.361L637.065 101.939L636.25 99.2961L629.837 102.447L621.489 105.394L622.202 102.04L615.788 102.548L621.591 99.7026L625.256 95.1291L630.448 89.9458L633.298 90.3523Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_15"
        d="M679.006 81.9165L674.018 82.2214L674.73 79.4773L678.599 76.3267L682.976 75.6152L685.318 77.1397L683.791 79.4773L682.874 80.2904L679.006 81.9165Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_16"
        d="M603.165 71.0421L598.991 72.9731L594.716 71.347L590.746 71.8551L587.284 69.4159L592.374 67.6882L597.363 65.3506L600.417 66.8751L602.045 67.8914L602.453 68.9078L603.165 71.0421Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_17"
        d="M657.119 215.971L654.88 212.312L657.832 203.674L656.203 201.844L652.436 202.86L651.317 201.234L645.718 206.011L642.46 210.991L639.61 213.939L637.065 214.955L635.334 215.26L634.214 216.784H624.747L616.806 216.886L614.058 218.004L607.135 222.476V222.374L606.219 221.968L604.183 222.882L602.249 224.204L600.417 223.086L595.632 223.899L591.662 224.813L589.728 225.626L587.386 227.761L589.219 228.472L590.949 228.066H591.255L590.949 229.997L586.063 230.708L583.212 231.521L581.482 232.537L578.835 231.928L577.206 232.233L574.254 234.062L569.571 236.095L566.823 235.688L568.859 233.452L572.625 229.895L576.799 227.761L577.919 225.931L578.835 222.882L582.703 219.325L583.62 215.26L584.739 219.223L588.608 220.138L591.051 218.004L589.626 213.125L588.71 211.093L584.638 209.873L580.769 209.162H576.799L573.338 208.349L572.931 206.926L571.505 207.841L570.284 207.637L572.218 205.503L570.386 204.69L572.32 202.251L571.098 200.421L572.829 198.592L567.535 197.677L567.433 194.018L566.619 193.205L563.26 193.002L559.086 191.782L557.559 192.595L555.726 194.12L552.367 195.136L549.211 197.677L543.714 195.949L539.235 196.762L535.265 194.831L530.582 193.815L527.222 193.409L526.204 192.392L527.121 188.937H525.39L524.067 191.376H513.683H496.377H479.275H464.106H449.04H434.075H418.704H413.817H398.853H384.499H383.786L378.289 185.176L376.66 182.432L369.534 179.79L370.858 174.2L374.522 170.439L370.349 167.695L373.504 162.715L371.367 158.243L373.912 154.991L379.103 152.044L382.361 148.182L377.678 144.32L379.103 137.307L380.223 133.038L378.594 130.294L377.78 127.855L378.391 124.704L371.774 126.635L364.037 129.989L363.732 126.127L363.223 123.485L360.372 121.858L356.097 121.655L392.337 88.421L417.38 67.6878L423.488 69.009L426.848 71.6515L430.614 72.1596L437.028 69.9237L444.154 68.1959L449.549 68.8057L458.609 66.4682L466.957 65.1469L467.16 67.3829L471.741 66.0616L475.712 63.5208L477.849 64.1306L479.275 69.009L488.946 65.2486L484.975 69.4155L491.083 68.5008L494.341 66.9763L499.024 67.2812L502.994 69.5172L510.629 71.5498L515.414 72.4645L519.893 72.1596L522.845 75.0054L514.192 77.7495L520.707 78.8675L532.821 78.2577L537.301 77.2413L538.726 80.5952L545.954 77.8511L543.816 75.4119L548.397 73.5825L553.69 73.2776L557.661 72.7694L559.798 74.0907L561.325 77.0381L566.415 76.6315L571.811 79.1724L579.14 78.2577L585.248 78.3593L587.692 74.9037L592.273 73.989L597.261 75.8184L592.883 81.1034L599.195 76.6315L602.453 76.8348L608.968 71.2449L607.339 67.891L604.387 65.6551L609.986 59.6587L618.333 55.7966L622.914 56.7113L624.95 59.0489L625.358 65.1469L619.453 67.7894L626.274 68.9074L621.795 74.4972L630.855 70.2286L633.094 73.7858L628.717 77.8511L630.04 81.6116L637.472 77.6479L644.089 72.7694L648.873 66.7731L654.472 67.1796L659.97 67.9927L663.634 70.7368L661.904 73.4809L656.712 76.4282L657.628 79.3756L655.185 82.1197L644.089 86.0834L637.472 86.9981L634.214 85.2704L630.855 88.1161L623.322 92.8929L620.268 95.4337L612.429 99.2958L605.812 99.7023L600.62 102.142L597.668 106.004L591.865 106.715L583.009 111.492L573.44 118.098L568.35 122.773L563.361 129.786L569.469 130.802L567.942 136.392L567.128 141.067L574.559 139.848L581.685 142.49L585.045 144.828L586.775 147.673L591.764 149.401L595.428 151.942L603.165 152.349L608.052 152.958L604.387 158.243L602.656 164.443L602.758 171.456L607.237 177.452L612.022 175.419L617.723 168.915L620.064 159.158L618.333 155.906L627.495 152.958L635.13 148.69L640.017 144.421L641.747 140.356L641.34 135.172L638.083 130.599L647.143 124.298L648.161 118.911L652.131 109.764L655.999 108.341L662.82 109.967L667.096 110.577L671.677 108.951L674.832 110.984L678.497 114.439L678.701 116.675L686.539 117.183L683.893 122.163L681.551 129.684L685.42 130.701L687.048 134.258L695.396 130.904L703.031 124.196L707.307 121.452L708.426 126.839L711.073 134.461L713.109 141.779L709.648 145.641L714.534 149.096L717.487 152.552L724.511 154.178L726.954 156.109V161.394L730.415 162.207L731.535 164.545L729.499 171.557L725.122 173.895L720.846 176.131L711.888 178.367L703.845 183.448L695.091 184.566L684.809 183.144H677.377L671.982 183.55L666.179 188.124L658.646 190.969L648.364 199.303L640.322 205.198L645.107 204.182L656.203 195.746L668.724 190.461L676.461 189.851L679.821 193.002L673.611 197.271L673 204.08L673.102 208.958L678.803 212.109L687.557 211.194L694.887 203.978L693.869 208.654L696.414 210.991L688.881 215.158L676.258 219.02L670.353 221.561L663.024 226.236L659.257 225.728L660.784 220.341L671.371 214.955L663.125 215.158L657.119 215.971Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_18"
        d="M548.702 49.4956L543.917 51.9348L554.606 50.4103L557.253 53.0528L564.685 50.3087L566.517 52.0364L564.277 57.2197L568.655 55.0854L571.505 49.6989L575.883 48.8858L578.937 49.6989L581.176 51.8332L578.428 57.0165L575.984 60.7769L580.26 63.4194L585.35 66.0619L582.703 68.3994L575.475 68.9076L576.29 70.9403L573.032 72.9729L566.212 72.1599L560.409 70.6354L555.217 70.9403L545.546 72.8713L534.043 73.6844L526.001 74.1926L526.306 71.5501L522.132 70.1272L517.755 70.737L517.144 66.3668L520.503 65.757L527.935 64.8423L533.534 65.1472L539.845 64.1308L533.228 62.9112L523.965 63.3178L518.162 63.2161V61.2851L530.073 59.0491L523.659 59.1508L518.162 57.7279L526.102 53.7642L531.396 51.6299L545.852 48.4792L548.702 49.4956Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_19"
        d="M588.913 47.9711L581.787 51.4266L579.445 47.7678L581.583 46.9547L587.182 46.7515L588.913 47.9711Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_20"
        d="M699.468 49.5969L698.755 51.0198L694.582 50.9181L690.408 50.8165L685.42 51.5279L684.503 51.1214L682.366 48.3773L684.096 46.5479L686.336 46.1414L694.887 46.7512L699.468 49.5969Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_21"
        d="M658.952 49.2921L659.257 52.5444L666.587 48.3774L678.497 46.2431L680.838 51.6297L677.581 55.0853L686.743 53.5608L692.138 51.4264L699.061 54.0689L702.827 56.6098L701.707 58.9473L710.055 57.7277L711.989 61.1833L720.54 63.3176L722.78 65.4519L723.696 70.6352L714.432 73.176L722.271 76.8348L728.277 78.0545L731.637 83.1361L738.254 83.5427L734.894 87.5064L723.798 94.1126L719.726 91.6734L715.858 86.1851L709.851 86.8966L707.51 90.2505L710.259 93.5028L714.84 96.1452L715.858 97.6697L715.756 103.463L712.091 107.63L707.306 106.004L698.552 101.43L702.216 106.41L705.067 109.967L704.761 112L693.665 109.663L685.928 106.207L682.06 103.463L684.503 101.735L679.617 98.7877L674.832 96.0436L673.916 97.6697L660.58 98.5844L658.137 96.6534L663.634 92.3848L671.88 92.2832L681.347 91.5717L681.144 89.539L684.3 86.6933L693.258 81.2051L693.665 78.6643L693.156 76.8348L688.372 74.0907L681.144 72.2613L684.707 70.8385L682.671 67.3829L679.21 67.078L677.275 65.2486L673.916 66.8748L665.874 67.5862L651.622 66.3666L644.089 64.7404L638.083 63.9274L636.148 61.9963L642.562 59.5571H636.759L640.119 54.1706L647.346 49.4954L653.454 47.3611L664.856 45.9382L658.952 49.2921Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_22"
        d="M607.644 45.7351L611.309 46.8531L619.046 46.1416L618.537 47.6661L612.327 50.207L616.195 52.4429L610.902 57.2197L602.35 59.2524L598.889 58.8458L597.973 56.8132L591.967 52.7478L593.697 51.0201L601.231 51.6299L600.314 48.2759L607.644 45.7351Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_23"
        d="M630.651 51.325L622.711 55.2888L618.231 55.0855L620.064 50.4103L622.711 47.8695L626.986 45.6336L632.28 44.2107L640.322 44.414L646.634 45.6336L636.352 50.3087L630.651 51.325Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_24"
        d="M512.767 58.6423L499.024 61.2848L499.634 58.9472L493.526 56.1015L498.006 53.8656L505.641 50.0035L513.378 46.5479L513.785 43.3973L528.037 42.5842L532.312 43.7022L541.983 44.0071L543.918 45.43L545.546 47.6659L538.929 48.9871L524.779 52.646L515.414 56.4064L512.767 58.6423Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_25"
        d="M640.22 39.9416L636.046 41.8727L630.753 41.4661L627.495 40.1449L632.076 37.909L639.1 36.4861L640.526 38.3155L640.22 39.9416Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_26"
        d="M631.262 31.1001L631.466 33.4377L628.615 35.9785L622.711 39.8406L615.686 40.3488L612.429 39.5357L615.89 36.5883L609.171 36.8932L613.549 33.0311L617.417 33.2344L625.256 31.5066L630.244 31.8115L631.262 31.1001Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_27"
        d="M591.153 33.7425L590.44 35.4703L594.919 34.6572L598.584 34.8605L596.243 37.4013L591.051 39.7389L576.901 40.552L564.379 42.7879L558.271 42.8896L559.798 41.2634L570.691 38.9259L552.469 39.5357L548.193 38.621L560.104 33.7425L565.601 32.3197L574.05 34.0474L577.002 36.9948L583.212 37.4013L583.925 32.6246L589.829 30.7952L592.985 31.3033L591.153 33.7425Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_28"
        d="M647.855 29.2705L650.197 30.8966H657.73L659.155 32.5228L656.305 34.3522L659.461 35.4701L660.682 36.6897L665.67 36.893L670.862 37.2995L678.09 36.2832L686.336 35.775L692.24 36.1816L694.582 38.1126L693.564 40.1453L689.899 41.5681L683.078 42.6861L678.701 41.9747L666.688 42.7877L658.544 42.8894L652.844 42.2796L644.089 40.6534L645.718 37.8077L647.855 35.3685L646.43 33.1326L639.304 32.5228L636.657 30.9982L640.526 28.9656L647.855 29.2705Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_29"
        d="M570.793 26.6279L564.888 30.3884L559.493 32.1161L555.624 32.3194L545.546 34.4537L538.318 35.2668L534.654 34.1488L546.564 30.3884L558.984 27.2377L564.583 27.3394L570.793 26.6279Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_30"
        d="M653.454 27.2379L651.622 27.3395L644.903 27.0346L645.616 25.7134L652.945 25.815L654.574 26.6281L653.454 27.2379Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_31"
        d="M593.596 26.3233L584.637 27.7461L581.278 26.2216L586.47 24.6971L592.578 24.189L596.752 24.9004L593.596 26.3233Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_32"
        d="M601.536 22.0547L595.733 22.9694H589.625L590.643 22.258L596.446 20.9368L598.177 21.14L601.536 22.0547Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_33"
        d="M649.179 24.5954L642.46 25.6117L640.831 24.4938L641.442 22.766L643.681 20.835L648.161 21.0382L649.891 21.3431L652.233 22.9693L649.179 24.5954Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_34"
        d="M635.13 23.3758L634.01 25.3068L628.615 24.7986L624.543 23.2741L616.602 23.0709L621.998 21.7496L619.147 20.6316L621.387 18.8022L627.597 19.412L635.232 21.1398L635.13 23.3758Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_35"
        d="M690.204 17.1762L692.952 18.7007L686.335 20.022L675.545 23.5791L668.622 23.884L661.7 23.2742L660.071 21.3432L662.209 19.7171L666.586 18.4975H659.867L657.831 16.973L658.239 15.0419L663.227 13.1109L667.401 11.7896L671.473 11.4847L671.167 10.4684L679.617 10.2651L681.245 12.5011L686.03 13.4158L690.916 14.3305L690.204 17.1762Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_36"
        d="M770.83 2.94755L779.686 3.25245L786.507 3.76062L791.8 4.77695L790.681 5.79329L780.704 7.52106L771.542 8.33413L767.47 9.24883H775.105L764.416 11.7897L757.494 13.0093L748.026 16.5665L739.781 17.2779L736.625 18.2942L725.121 18.7008L729.601 19.3106L726.241 20.1236L726.954 22.4612L721.864 24.0873L714.84 25.4086L711.277 27.238L704.558 28.7625L704.049 29.8805L710.666 29.6772L709.546 30.8968L696.617 33.8442L687.964 32.4213L676.054 33.2344L670.964 32.6246L664.042 32.3197L666.179 29.9821L674.323 28.8641L676.359 25.4086L679.006 25.1037L686.641 27.1363L684.91 24.0873L679.922 23.1726L685.012 21.3432L692.749 20.2253L695.599 18.5991L692.545 16.8714L693.665 14.6354L703.234 14.737L705.474 15.2452L712.905 13.6191L705.474 13.1109L692.647 13.4158L688.168 11.9929L687.354 10.2652L684.809 9.04557L685.928 7.72433L692.036 6.91126L696.312 6.80963L703.845 6.19983L710.768 4.67532L714.738 4.87859L717.181 5.99656L722.271 3.96389L727.565 3.35408L734.182 2.94755L744.769 2.74428L746.092 3.15082L756.578 2.54102L763.704 2.74428L770.83 2.94755Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="CH"
        d="M1053.02 200.726L1053.22 201.844L1052.51 203.369L1054.85 204.589L1057.5 204.792L1057.19 207.333L1055.06 208.451L1051.19 207.638L1050.17 210.178L1047.73 210.382L1046.81 209.365L1044.06 211.601L1041.52 211.906L1039.28 210.483L1037.44 207.739L1035 208.755V205.808L1038.67 202.251L1038.46 200.625L1040.8 201.235L1042.13 200.117H1046.4L1047.42 198.795L1053.02 200.726Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="CI"
        d="M973.106 442.31L975.651 443.732L976.669 445.968L979.214 447.29L981.25 445.663L983.897 445.46L987.867 447.086L989.394 456.437L986.951 461.823L985.424 469.242L987.867 474.832L987.663 477.475H985.017L981.046 476.255H977.28L970.459 477.475L966.489 479.304L960.788 481.743L959.668 481.54L960.076 476.153L960.686 475.34L960.483 472.8L958.04 470.055L956.207 469.649L954.578 467.82L955.8 464.872L955.291 461.721L955.495 459.892H956.411L956.818 457.046L956.411 455.725L956.92 454.81L959.058 454.099L957.632 448.814L956.309 446.172L956.818 443.936L957.938 443.427L958.752 442.818L960.279 443.834H964.758L965.776 442.005L966.794 442.106L968.423 441.395L969.339 444.139L970.663 443.326L973.106 442.31Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="CM"
        d="M1092.11 461.62L1089.26 468.226L1087.83 469.344L1087.43 474.426L1088.04 477.17L1087.53 479.101L1090.28 482.557L1090.79 484.894L1092.92 488.248L1095.57 490.382L1095.88 493.33L1096.49 495.261L1096.08 498.716L1091.5 497.192L1086.82 495.464L1079.59 495.261L1078.88 494.854L1075.42 495.667L1071.95 494.854L1069.21 495.261L1059.74 495.159L1060.65 489.976L1058.31 485.606L1055.67 484.589L1054.55 481.642L1053.02 480.727L1053.12 478.898L1054.55 474.223L1057.29 467.921H1058.92L1062.38 464.059L1064.52 463.958L1067.78 466.702L1071.75 464.466L1072.26 461.722L1073.58 459.079L1074.4 455.827L1077.45 453.184L1078.57 448.611L1079.79 447.086L1080.61 443.733L1082.03 439.566L1086.82 434.484L1087.12 432.35L1087.73 431.13L1085.39 428.589L1085.6 426.455L1087.12 426.15L1089.46 430.317L1089.97 434.586L1089.77 438.956L1093.03 444.851H1089.77L1088.14 445.257L1085.49 444.647L1084.27 447.696L1087.73 451.558L1090.28 452.676L1091.09 455.319L1092.92 459.791L1092.11 461.62Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="CD"
        d="M1161.84 475.849L1165.41 481.235L1168.05 482.048L1169.58 480.93L1172.23 481.337L1175.38 480.016L1176.81 482.76L1182 487.13L1181.69 494.753L1184.04 495.667L1182.1 497.903L1179.96 499.733L1177.72 503.086L1176.5 506.136L1176.2 511.319L1174.87 513.86L1174.77 518.738L1173.14 520.567L1172.94 524.43L1172.13 524.938L1171.51 528.597L1172.94 531.544L1173.04 532.56L1171.82 543.028L1173.35 546.687L1172.33 549.431L1174.16 554.107L1177.62 557.664L1178.34 561.221L1179.96 562.949L1179.66 564.067L1178.74 563.762L1170.9 564.88L1169.38 565.693L1167.65 569.86L1168.87 572.706L1167.75 580.43L1166.83 586.934L1168.36 588.154L1172.33 590.695L1173.96 589.475L1174.16 596.488H1169.78L1167.54 592.931L1165.51 590.085L1161.13 589.17L1159.91 585.816L1156.35 587.849L1151.87 586.934L1149.93 583.987L1146.37 583.377L1143.62 583.479L1143.32 581.446L1141.38 581.344L1138.73 580.938L1135.17 581.954L1132.73 581.751L1131.3 582.361L1131.71 574.637L1129.88 572.197L1129.47 568.132L1130.39 564.168L1129.27 561.729L1129.17 557.562L1122.24 557.664L1122.75 555.326H1119.8L1119.49 556.444L1115.93 556.749L1114.4 560.509L1113.49 562.136L1110.33 561.221L1108.5 562.136L1104.63 562.644L1102.49 559.29L1101.17 557.156L1099.54 553.192L1098.22 548.415L1081.22 548.313L1079.18 549.025L1077.45 548.923L1075.11 549.838L1074.3 547.805L1075.72 547.094L1075.92 544.248L1076.94 542.622L1078.98 541.199L1080.51 541.911L1082.54 539.37L1085.7 539.471L1086 541.301L1088.14 542.419L1091.6 538.353L1094.96 535.203L1096.39 533.068L1096.28 527.682L1098.83 521.381L1101.48 518.027L1105.24 514.876L1105.96 512.843L1106.06 510.404L1106.97 508.168L1106.67 504.408L1107.38 498.615L1108.5 494.549L1110.23 491.094L1110.54 487.13L1111.05 482.557L1113.28 479.304L1116.34 477.17L1121.12 479.406L1124.79 481.845L1128.96 482.455L1133.34 483.776L1134.97 479.812L1135.78 479.304L1138.43 479.914L1144.84 476.662L1147.08 478.085L1148.91 477.881L1149.83 476.255L1151.97 475.747L1156.24 476.458L1160.01 476.56L1161.84 475.849Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="CG"
        d="M1110.54 487.13L1110.23 491.093L1108.5 494.549L1107.38 498.614L1106.67 504.407L1106.97 508.168L1106.06 510.404L1105.96 512.843L1105.24 514.876L1101.48 518.026L1098.83 521.38L1096.28 527.682L1096.39 533.068L1094.96 535.202L1091.6 538.353L1088.14 542.418L1086 541.3L1085.7 539.471L1082.54 539.369L1080.51 541.91L1078.98 541.199L1076.84 538.963L1075.11 540.081L1072.77 542.927L1068.09 536.015L1072.46 532.357L1070.33 528.088L1072.36 526.462L1076.23 525.649L1076.64 522.701L1079.79 525.852L1084.88 526.157L1086.61 523.108L1087.33 518.738L1086.71 513.656L1083.97 509.794L1086.51 502.171L1085.09 500.952L1080.81 501.46L1079.18 498.106L1079.59 495.26L1086.82 495.464L1091.5 497.191L1096.08 498.716L1096.49 495.26L1099.54 489.162L1102.9 485.707L1106.87 486.825L1110.54 487.13Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="CO"
        d="M594.919 433.162L591.153 434.28L589.524 437.533L587.182 439.362L585.35 441.801L584.434 446.476L582.601 450.339L585.554 450.745L586.164 453.692L587.386 455.217L587.691 457.758L586.979 460.197L587.081 461.62L588.506 462.128L589.727 464.364L597.159 463.754L600.518 464.567L604.387 470.259L606.728 469.547L610.902 469.852L614.159 469.141L616.195 470.259L614.974 473.714L613.65 475.95L613.04 480.625L614.159 484.996L615.686 486.927L615.89 488.349L612.938 491.602L614.974 493.025L616.501 495.362L618.13 501.867L617.01 502.68L615.992 498.818L614.363 496.683L612.429 499.021L601.231 498.818V502.883L604.59 503.595L604.387 506.135L603.267 505.424L600.009 506.44L599.907 511.217L602.554 513.656L603.47 517.315L603.369 520.161L601.129 538.048L598.177 534.593L596.446 534.491L600.009 527.783L595.53 524.734L592.069 525.344L589.931 524.226L586.775 525.954L582.5 525.039L578.937 518.23L576.29 516.604L574.457 513.453L570.589 510.404L569.062 511.014L566.619 509.489L563.768 507.355L562.14 508.371L557.253 507.457L555.828 504.611L554.708 504.712L549.007 501.054L548.295 499.021L550.433 498.513L550.229 495.261L551.654 492.821L554.505 492.415L557.05 488.349L559.289 484.894L557.253 483.369L558.475 479.609L557.355 473.613L558.678 471.885L557.966 466.397L555.726 462.839L556.642 459.689L558.475 460.197L559.595 458.266L558.475 454.404L559.187 453.489L562.14 453.692L566.721 449.119L569.164 448.407L569.266 446.273L570.691 440.683L574.152 437.736L577.715 437.533L578.326 436.211L582.805 436.72L587.488 433.467L589.829 432.044L592.781 428.894L594.817 429.3L596.141 431.028L594.919 433.162Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="CR"
        d="M523.863 438.651L525.084 442.208L527.12 444.85L529.665 447.594L527.426 448.204L527.324 450.847L528.444 451.761L527.527 452.575L527.731 453.693L527.12 455.014L526.815 456.335L523.761 454.912L522.641 453.489L523.354 452.371L523.252 450.948L521.725 449.424L519.485 448.103L517.653 447.29L517.347 445.359L515.922 444.241L516.126 446.07L514.904 447.696L513.683 445.867L511.952 445.155L511.239 443.936L511.341 441.903L512.257 439.87L510.73 438.956L512.156 437.634L513.072 436.821L516.737 438.549L518.06 437.736L519.892 438.244L520.707 439.565L522.437 440.074L523.863 438.651Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="CU"
        d="M554.606 361.51L556.54 363.848L561.834 363.136L563.666 364.661L567.942 368.726L571.2 371.674L573.032 371.572L576.29 372.893L575.679 374.723L579.751 375.028L583.721 377.67L582.907 379.195L579.038 380.008L575.17 380.313L571.403 379.804L563.157 380.414L567.433 376.857L565.295 375.129L561.63 374.723L559.9 372.792L559.085 369.133L555.828 369.336L550.738 367.608L549.211 366.185L541.983 365.169L540.151 363.95L542.492 362.323L536.995 362.018L532.516 365.372L530.174 365.474L529.156 367.1L526.306 367.812L523.964 367.1L527.222 365.169L528.749 362.73L531.498 361.307L534.552 360.087L538.929 359.478L540.354 358.665L545.139 359.173L549.618 359.274L554.606 361.51Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="CZ"
        d="M1078.77 178.062L1081.32 180.095L1085.09 180.603L1084.88 182.331L1087.73 183.652L1088.34 182.026L1091.81 182.737L1092.52 184.77L1096.28 185.075L1098.93 188.226H1097.4L1096.69 189.344L1095.57 189.649L1095.37 191.071L1094.45 191.376L1094.35 191.986L1092.72 192.596L1090.48 192.494L1089.87 193.917L1087.43 192.698L1085.09 193.002L1081.01 191.071L1079.28 191.58L1076.64 194.222L1072.77 192.088L1069.71 189.445L1067.07 187.921L1066.35 185.177L1065.34 183.347L1068.8 182.026L1070.53 180.4L1074.09 179.18L1075.21 177.961L1076.53 178.672L1078.77 178.062Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="DE"
        d="M1072.87 161.496L1074.3 164.647L1073.07 166.374L1075.01 168.509L1076.54 171.863L1076.33 174.099L1078.77 178.062L1076.54 178.672L1075.21 177.961L1074.09 179.18L1070.53 180.4L1068.8 182.026L1065.34 183.347L1066.36 185.177L1067.07 187.921L1069.71 189.445L1072.77 192.088L1071.14 195.035L1069.41 195.848L1070.43 200.015L1070.02 201.133L1068.29 199.812L1065.85 199.609L1062.28 200.727L1057.8 200.422L1057.19 202.149L1054.44 200.422L1053.02 200.727L1047.42 198.796L1046.4 200.117H1042.13L1042.53 195.543L1044.98 191.275L1037.65 190.055L1035.2 188.429L1035.41 185.685L1034.39 184.262L1034.8 179.993L1033.68 173.387H1036.63L1037.85 171.05L1038.77 165.358L1037.85 163.224L1038.67 161.903L1042.74 161.598L1043.76 162.919L1046.91 159.87L1045.59 157.532L1045.18 154.077L1048.95 154.89L1051.9 153.975L1052.2 156.313L1057.19 157.736L1057.29 159.971L1062.08 158.752L1064.73 157.126L1070.43 159.565L1072.87 161.496Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="DJ"
        d="M1251.63 435.195L1249.7 438.753L1248.37 437.533L1247.05 438.041L1243.79 437.939L1243.59 435.907L1243.08 434.077L1244.91 431.028L1246.85 428.183L1249.29 428.792L1251.02 427.166L1252.45 429.199L1252.34 431.841L1249.19 433.468L1251.63 435.195Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_37"
        d="M1064.93 150.113L1062.49 155.093L1057.19 151.536L1056.28 148.995L1063.2 146.962L1064.93 150.113Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_38"
        d="M1051.9 153.975L1048.95 154.889L1045.18 154.076L1043.04 150.621L1042.64 144.421L1043.25 142.693L1044.57 140.864L1048.64 140.559L1050.27 138.831L1053.94 137.104V140.254L1052.71 142.287L1053.43 143.913L1056.07 144.828L1055.06 147.165L1053.63 146.555L1050.47 150.926L1051.9 153.975Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="DO"
        d="M596.243 392.305L596.548 390.476L595.225 388.545L596.752 387.427L597.464 384.886L597.362 381.431L598.177 380.313H602.554L605.812 381.939L607.339 381.837L608.051 384.175L611.207 383.972L610.8 385.903L613.345 386.207L615.89 388.545L613.549 391.188L610.902 389.765L608.255 390.07L606.423 389.765L605.303 390.984L603.063 391.391L602.351 389.765L600.416 390.679L597.668 395.151L596.344 394.135L596.243 392.305Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="DZ"
        d="M1049.56 268.922L1048.54 272.276L1049.56 278.476L1048.44 283.863L1045.18 287.521L1045.79 292.4L1050.37 296.364L1050.47 297.888L1053.94 300.53L1056.58 312.218L1058.52 318.011L1058.92 321.06L1058.11 326.345L1058.52 329.394L1057.91 332.952L1058.52 337.017L1056.28 339.761L1059.74 344.538L1059.94 347.282L1062.08 350.941L1064.62 349.721L1069.21 352.77L1071.75 356.836L1052.61 369.336L1036.32 382.142L1028.38 384.988L1022.07 385.699L1021.97 381.532L1019.32 380.414L1015.76 378.585L1014.44 375.536L995.4 361.307L976.466 347.079L955.596 331.224L955.698 330.004L955.8 329.598L955.902 321.874L964.962 316.995L970.459 315.979L975.04 314.251L977.178 310.999L983.693 308.458L983.999 303.579L987.155 302.97L989.7 300.632L996.927 299.514L997.945 296.973L996.52 295.55L994.586 288.639L994.281 284.676L992.346 280.509L997.538 276.951L1003.44 275.833L1006.8 273.191L1011.99 271.158L1021.16 270.04L1030.11 269.532L1032.86 270.447L1037.85 267.906L1043.65 267.804L1045.89 269.329L1049.56 268.922Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="EC"
        d="M569.062 511.014L569.876 515.994L568.146 520.161L561.936 527.072L555.115 529.613L551.654 535.304L550.738 539.674L547.582 542.419L545.037 539.065L542.696 538.353L540.354 538.861L540.049 536.524L541.678 534.999L540.965 532.255L543.917 527.377L542.594 524.531L540.456 527.58L536.893 524.633L538.013 522.803L536.995 516.909L539.031 515.892L540.049 511.827L542.187 507.66L541.881 505.017L545.037 503.595L549.007 501.054L554.708 504.713L555.828 504.611L557.253 507.457L562.14 508.371L563.768 507.355L566.619 509.489L569.062 511.014Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="EG"
        d="M1193.2 306.324L1197.17 315.877L1197.88 317.503L1196.56 320.146L1195.84 325.024L1194.62 328.48L1193.4 329.598L1191.37 327.464L1188.62 324.618L1183.83 315.268L1183.32 315.877L1186.17 322.687L1190.14 329.293L1195.13 339.456L1197.47 343.013L1199.51 346.672L1205.01 353.888L1203.99 355.006L1204.4 359.275L1211.32 365.17L1212.44 366.491H1189.94H1168.05H1145.35L1144.33 342.404L1143.01 319.231L1140.97 313.946L1142.09 309.983L1141.08 307.137L1142.81 303.986L1150.14 303.885L1155.63 305.612L1161.23 307.543L1163.88 308.56L1167.95 306.527L1170.09 304.698L1174.87 304.088L1178.84 304.901L1180.68 308.153L1181.8 306.019L1186.28 307.543L1190.65 307.95L1193.2 306.324Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="ER"
        d="M1251.02 427.166L1249.29 428.792L1246.85 428.182L1244.81 426.048L1242.27 422.288L1239.62 420.153L1238.09 417.917L1233 415.275L1229.03 415.173L1227.61 413.852L1224.35 415.377L1220.68 412.429L1219.16 417.308L1212.44 415.885L1211.73 413.344L1213.76 403.689L1214.07 399.42L1215.8 397.387L1219.87 396.269L1222.62 392.611L1226.28 400.132L1228.22 406.128L1231.47 409.279L1239.62 415.478L1242.98 419.137L1246.24 422.999L1248.07 425.235L1251.02 427.166Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="EE"
        d="M1133.75 126.636L1134.66 127.652L1132.02 131.107L1134.46 136.799L1132.83 138.73L1128.96 138.628L1124.48 136.392L1122.35 135.681L1118.48 136.697L1118.38 133.14L1116.85 133.953L1113.49 131.819L1112.47 128.363L1118.07 126.636L1123.77 125.823L1128.96 126.737L1133.75 126.636Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="FI"
        d="M1123.97 71.2449L1124.38 75.107L1131.81 78.8674L1128.86 83.1361L1135.48 89.539L1133.75 94.4174L1138.73 98.686L1137.82 102.548L1145.35 106.512L1144.44 109.459L1140.97 112.915L1132.83 120.436L1124.69 120.944L1116.95 123.078L1109.72 124.399L1106.46 121.147L1101.68 119.216L1101.78 113.321L1098.73 108.036L1100.36 104.581L1103.72 101.024L1112.67 94.7223L1115.32 93.5027L1114.4 91.0635L1107.79 88.421L1105.96 86.1851L1104.12 77.5462L1096.79 73.7858L1090.69 71.0417L1092.92 69.6188L1098.12 72.4645L1103.51 72.2613L1108.3 73.5825L1111.76 71.1433L1112.88 67.0779L1118.88 65.2485L1124.79 67.3828L1123.97 71.2449Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="GA"
        d="M1079.59 495.26L1079.18 498.106L1080.81 501.46L1085.09 500.952L1086.51 502.171L1083.97 509.794L1086.71 513.656L1087.33 518.738L1086.61 523.108L1084.88 526.157L1079.79 525.852L1076.64 522.701L1076.23 525.649L1072.36 526.462L1070.33 528.088L1072.46 532.357L1068.09 536.015L1062.18 529.409L1058.41 524.023L1054.85 517.315L1055.05 515.079L1056.38 513.046L1057.7 508.269L1058.92 503.391L1060.86 503.086H1069.21V495.26L1071.95 494.854L1075.42 495.667L1078.88 494.854L1079.59 495.26Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_39"
        d="M973.92 160.785L970.357 159.565L967.303 159.667L968.525 156.313L967.609 153.061L971.681 152.756L976.669 156.618L973.92 160.785Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="GE"
        d="M1237.58 231.623L1242.77 232.944L1244.91 235.587L1248.58 237.111L1247.36 237.924L1250.72 241.481L1250.1 242.193L1247.15 241.888L1242.88 239.957L1241.76 241.075L1234.63 242.091L1228.93 238.839L1223.33 239.144L1223.64 236.4L1221.5 232.03L1218.04 229.59L1214.98 228.879L1212.74 226.948L1213.15 226.135L1217.83 227.253L1225.67 228.269L1233.41 231.42L1234.63 232.639L1237.58 231.623Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="GH"
        d="M1004.26 438.143L1003.85 440.175L1006.19 443.529V448.306L1006.8 453.388L1008.23 455.827L1006.9 461.62L1007.41 464.872L1008.94 469.039L1010.26 471.377L1001.2 475.137L997.945 477.373L992.754 479.304L987.664 477.475L987.867 474.832L985.424 469.243L986.951 461.823L989.394 456.437L987.867 447.086L987.053 442.208L987.256 438.448L997.233 438.143L999.778 438.651L1001.61 437.635L1004.26 438.143Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="GN"
        d="M938.087 428.792L938.392 431.231H939.309L940.836 430.317L941.752 430.52L943.381 432.248L945.824 432.756L947.351 431.333L949.285 430.418L950.608 429.504L951.728 429.707L953.052 431.13L953.662 432.959L956.004 435.703L954.884 437.329L954.579 439.464L955.8 438.854L956.513 439.565L956.207 441.496L957.938 443.427L956.818 443.936L956.309 446.171L957.633 448.814L959.058 454.099L956.92 454.81L956.411 455.725L956.818 457.046L956.411 459.892H955.495L953.866 459.689L952.746 462.331H951.117L949.998 460.908L950.405 458.266L947.962 454.302L946.536 455.014L945.213 455.217L943.686 455.522L943.788 453.184L942.872 451.456L943.075 449.525L941.854 446.781L940.225 444.444H935.644L934.32 445.663L932.692 445.867L931.674 447.289L931.063 449.017L927.907 451.965L925.464 448.103L923.224 445.562L921.799 444.647L920.374 443.326L919.763 440.48L918.949 439.057L917.218 437.939L919.865 434.789L921.595 434.89L923.122 433.874L924.344 433.772L925.26 432.959L924.853 430.825L925.464 430.113L925.566 427.877L928.314 427.979L932.488 429.504L933.71 429.402L934.117 428.69L937.273 429.199L938.087 428.792Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="GM"
        d="M907.649 424.219L908.463 421.271L914.673 421.17L915.996 419.544L917.829 419.442L920.068 421.068H921.799L923.733 420.052L924.853 421.881L922.308 423.406L919.865 423.202L917.422 421.881L915.284 423.406H914.266L912.841 424.32L907.649 424.219Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="GW"
        d="M925.566 427.877L925.464 430.113L924.853 430.825L925.26 432.959L924.344 433.772L923.122 433.874L921.595 434.89L919.865 434.788L917.218 437.939L914.266 435.297L911.823 434.788L910.499 432.959L910.601 431.943L908.87 430.622L908.463 429.199L911.517 428.182L913.451 428.386L914.978 427.573L925.566 427.877Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="GQ"
        d="M1069.21 495.26V503.086H1060.86L1058.92 503.391L1057.8 502.476L1059.74 495.159L1069.21 495.26Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_41"
        d="M1132.73 277.053L1135.88 279.289L1140.06 278.883L1144.13 279.289V280.509L1146.98 279.696L1146.47 281.627L1138.73 282.135L1138.63 281.119L1131.91 279.798L1132.73 277.053Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_42"
        d="M1142.09 243.819L1138.84 243.616L1136.09 243.006L1129.78 244.632L1133.85 248.291L1131.3 249.409H1128.35L1125.2 246.055L1124.28 247.478L1125.91 251.34L1128.86 254.389L1126.93 255.812L1130.18 258.759L1133.03 260.69L1133.44 264.349L1128.35 262.621L1130.18 265.975L1126.82 266.585L1129.37 272.378L1125.81 272.48L1121.12 269.634L1118.68 264.451L1117.36 260.08L1115.02 257.133L1111.96 253.373L1111.45 251.543L1113.69 248.393L1113.79 246.258L1115.52 245.344L1115.42 243.616L1118.88 243.108L1120.72 241.685L1123.57 241.786L1124.38 240.668L1125.4 240.465L1129.27 240.668L1133.34 238.839L1137.31 241.177L1141.99 240.567L1141.69 237.314L1144.44 239.042L1143.32 243.108L1142.09 243.819Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="GL"
        d="M912.433 1.42289L932.691 4.4719L925.871 5.89477L912.637 6.09804L893.804 6.50457L895.229 7.21601L907.75 6.70784L917.625 8.13071L924.751 6.91111L927.194 8.33398L922.613 10.7732L931.979 9.14705L949.387 7.62254L959.567 8.43561L961.297 10.1634L946.231 13.1108L943.991 14.1271L932.386 14.9402L940.632 15.1434L935.644 18.3957L931.979 21.3431L930.757 26.628L934.524 29.8803L928.518 29.9819L921.901 31.6081L928.314 34.2505L928.212 38.5192L923.937 39.0273L928.11 43.3976L919.254 43.8041L923.326 45.8368L921.697 47.6662L915.894 48.4793L910.295 48.5809L914.571 52.0364L914.062 54.4756L906.631 52.2397L904.187 53.6626L909.277 54.9838L913.96 58.2361L914.571 62.6063L907.038 63.6227L904.289 61.4884L900.014 58.4393L900.523 62.0982L895.025 64.9439L905.918 65.1472L911.517 65.4521L899.403 70.2288L886.983 74.5991L874.055 76.4285L869.372 76.5301L864.384 78.6644L856.749 84.5592L846.365 88.5229L843.311 88.8278L837.101 90.149L830.382 91.5719L825.496 95.0274L824.071 99.0928L820.61 102.955L811.855 107.63L812.16 112.204L808.495 117.082L804.322 122.875L797.705 123.282L792.615 118.403L783.453 118.302L780.195 115.049L779.381 109.358L774.494 102.04L773.782 98.2797L775.309 93.0964L771.542 87.9131L774.901 83.7461L772.967 81.7134L780.093 75.2089L787.423 73.0746L790.07 70.8386L792.92 66.57L787.321 68.5011L784.674 69.3141L780.5 70.0256L776.225 68.2978L777.752 64.5374L780.806 61.6916L784.674 61.59L792.411 63.1145L787.016 59.659L784.267 57.8295L779.788 58.541L777.141 57.2197L784.267 52.3413L782.944 50.3087L781.824 46.7515L780.399 41.2633L776.734 39.3322L778.159 37.1979L769.913 34.2505L762.075 33.844L751.793 34.0473L742.122 34.4538L738.966 32.8277L735.098 29.677L746.296 28.1525L754.032 27.9493L739.17 26.628L732.553 24.697L734.792 22.8676L750.775 20.6316L766.045 18.3957L768.895 16.7696L760.649 15.1434L765.332 13.4157L780.297 10.4683L785.794 10.0617L785.998 8.23234L795.16 7.11437L806.358 6.50457H816.945L819.795 7.72418L830.586 5.48824L837.814 7.01274L842.497 7.31764L848.808 8.63888L841.988 6.50457L843.616 4.7768L856.545 2.54086L868.354 2.74413L873.546 1.32126L885.66 1.01636L912.433 1.42289Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="GT"
        d="M496.886 393.83L496.173 399.013L494.85 406.331H496.58L498.311 407.55L498.922 406.534L500.449 407.347L497.598 409.888L494.646 411.717L494.137 412.937L494.443 414.258L493.119 415.884L491.694 416.291L491.999 417.104L490.778 417.815L488.742 419.442L488.436 420.356L485.586 419.238L482.023 419.137L479.58 417.815L476.729 415.173L477.137 413.242L477.951 411.717L477.238 410.498L480.598 405.213H487.927L488.335 402.977L487.52 402.57L487.011 401.148L485.077 399.623L483.245 397.489L485.79 397.387L486.299 393.728H491.592L496.886 393.83Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="HN"
        d="M528.953 412.125L527.019 412.023L526.103 412.938L524.067 413.751H522.641L521.318 414.564L520.198 414.361L519.282 413.344L518.671 413.548L517.755 415.072L517.246 414.97L517.042 416.393L514.905 418.121L513.683 418.934L513.072 419.747L511.545 418.426L510.12 420.154H508.898L507.575 420.255L507.371 423.508H506.557L505.743 425.032L503.91 425.337L503.096 423.304L501.365 422.695L502.078 420.052L501.365 419.341L500.144 418.934L497.599 419.646L497.497 418.832L495.868 417.714L494.748 416.495L493.119 415.885L494.443 414.259L494.137 412.938L494.646 411.718L497.599 409.889L500.449 407.348L501.06 407.653L502.383 406.535L504.012 406.433L504.521 406.941L505.437 406.636L508.084 407.246L510.731 407.043L512.563 406.332L513.378 405.62L515.108 405.925L516.432 406.332L517.959 406.23L519.18 405.62L521.725 406.535L522.54 406.738L524.168 407.958L525.695 409.381L527.63 410.397L528.953 412.125Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="HR"
        d="M1100.97 210.991L1102.49 213.532L1104.22 215.361L1102.49 217.801L1100.05 216.378L1096.49 216.479L1091.91 215.361L1089.57 215.463L1088.55 216.886L1086.51 215.361L1085.7 218.004L1088.45 221.053L1089.77 222.984L1092.31 225.423L1094.45 226.846L1096.59 229.59L1101.48 232.029L1100.97 233.046L1095.88 230.708L1092.62 228.371L1087.73 226.439L1082.95 221.764L1083.97 221.256L1081.42 218.512L1081.12 216.378L1077.76 215.361L1076.33 218.106L1074.7 215.971V213.735L1074.8 213.634L1078.47 213.837L1079.28 212.821L1081.12 213.837L1083.15 213.939L1083.05 212.211L1084.78 211.499L1085.09 208.958L1089.06 207.231L1090.69 208.044L1094.76 210.788L1099.13 212.008L1100.97 210.991Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="HT"
        d="M597.362 381.431L597.464 384.886L596.752 387.427L595.225 388.545L596.548 390.476L596.243 392.306L592.578 391.188L589.829 391.594L586.368 391.188L583.619 392.407L580.769 390.375L581.482 388.24L586.673 389.155L590.847 389.663L593.087 388.24L590.745 385.395L591.153 382.854L587.59 381.837L589.117 380.11L592.578 380.313L597.362 381.431Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="HU"
        d="M1115.93 195.035L1118.99 196.763L1119.49 198.491L1116.54 199.812L1114.61 204.08L1111.96 208.451L1107.99 209.67L1104.73 209.365L1100.97 210.992L1099.13 212.008L1094.76 210.788L1090.69 208.044L1089.06 207.231L1087.83 205.097L1087.02 204.995L1088.34 200.93L1087.22 199.507H1090.07L1090.28 196.865L1093.03 198.592L1094.96 199.202L1099.13 198.491L1099.44 197.169L1101.37 196.966L1103.72 196.051L1104.33 196.458L1106.67 195.645L1107.69 194.12L1109.31 193.714L1114.91 195.645L1115.93 195.035Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="IE"
        d="M973.921 160.785L974.633 165.257L970.663 170.846L961.705 174.505L954.782 173.591L959.16 167.086L957.022 160.785L963.843 155.906L967.609 153.061L968.525 156.313L967.304 159.667L970.358 159.565L973.921 160.785Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="IS"
        d="M941.446 85.8807L940.021 89.5395L944.5 93.4015L938.291 97.7718L924.955 101.735L920.984 102.853L915.284 101.939L903.169 100.109L908.056 97.5685L898.894 94.8244L906.936 93.7064L907.038 91.9787L898.079 90.6574L901.744 86.897L908.463 86.0839L914.571 89.946L921.697 86.897L926.889 88.4215L934.32 85.4741L941.446 85.8807Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="IL"
        d="M1200.32 292.908L1200.73 295.55L1200.12 296.567H1200.22L1199.51 298.599L1197.37 297.786L1196.66 302.055L1198.19 302.766L1196.86 303.681L1196.76 305.409L1199.31 304.596L1199.71 307.137L1197.88 317.503L1197.17 315.877L1193.2 306.324L1194.62 304.189L1194.22 303.783L1195.34 300.734L1195.95 295.855L1196.56 294.128H1196.66H1198.49L1198.9 293.01L1200.32 292.908Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_43"
        d="M1087.43 260.588L1085.7 265.771L1086.61 267.702L1085.7 271.056L1081.42 268.617L1078.67 267.906L1071.04 264.653L1071.55 261.3L1077.86 261.909L1083.36 261.198L1087.43 260.588Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_44"
        d="M1052.82 241.278L1056.18 245.851L1055.77 254.49L1053.32 254.084L1051.19 256.218L1049.15 254.49L1048.64 246.664L1047.32 243.006L1050.27 243.311L1052.82 241.278Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_45"
        d="M1074.91 207.231L1074.5 210.382L1075.92 213.126L1071.75 212.11L1067.78 214.447L1068.19 217.598L1067.68 219.427L1069.61 222.68L1074.7 225.932L1077.65 231.318L1083.86 236.502L1087.94 236.4L1089.36 237.823L1087.94 239.144L1092.82 241.482L1096.89 243.413L1101.68 246.868L1102.29 247.986L1101.48 250.324L1098.32 247.275L1093.64 246.259L1091.7 250.426L1095.67 252.865L1095.27 256.219L1093.13 256.625L1090.58 262.215L1088.34 262.723L1088.24 260.691L1089.16 257.235L1090.28 255.812L1087.94 252.052L1086.1 248.799L1083.86 247.986L1082.03 245.242L1078.57 244.023L1076.13 241.38L1072.26 240.974L1067.88 238.128L1062.89 233.859L1059.13 230.2L1057.19 223.798L1054.55 223.086L1050.27 220.952L1047.93 221.765L1044.98 224.814L1042.84 225.22L1043.35 222.476L1040.5 221.663L1038.97 216.683L1040.7 214.752L1039.17 212.313L1039.28 210.483L1041.52 211.906L1044.06 211.601L1046.81 209.366L1047.73 210.382L1050.17 210.179L1051.19 207.638L1055.06 208.451L1057.19 207.333L1057.5 204.792L1060.65 205.707L1061.16 204.487L1066.15 203.369L1067.47 205.503L1074.91 207.231Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="JM"
        d="M566.517 393.423L564.685 394.541L561.631 393.423L558.678 391.086L559.493 389.561L561.936 389.155L563.259 389.358L567.026 389.968L569.775 391.492L570.589 393.322L566.517 393.423Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="JO"
        d="M1219.67 300.124L1218.75 301.14L1208.16 304.393L1214.27 310.999L1212.64 312.015L1211.93 314.251L1207.76 315.166L1206.64 317.503L1204.5 319.536L1198.19 318.418L1197.88 317.503L1199.71 307.137L1199.31 304.596L1199.92 302.665L1199.51 298.599L1200.22 296.567L1206.64 299.209L1216.51 292.197L1219.67 300.124Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="KE"
        d="M1245.52 484.487L1240.53 491.805L1240.74 515.587L1244.1 520.974L1240.03 523.616L1238.6 526.361L1236.36 526.767L1235.55 531.442L1233.61 534.085L1232.49 538.353L1230.15 540.488L1221.91 533.983L1221.6 530.223L1200.73 516.909L1201.14 512.132L1199.71 509.591V509.286L1201.34 506.644L1204.19 502.375L1206.33 497.598L1203.68 490.077L1202.97 486.825L1200.22 482.252L1203.68 478.389L1207.55 474.121L1210.5 475.239L1210.61 478.898L1212.54 481.032H1216.61L1223.94 486.52L1225.77 486.622L1227.1 486.419L1228.42 487.13L1232.29 487.74L1233.92 484.996L1239.21 482.252L1241.55 484.487H1245.52Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="LB"
        d="M1200.32 292.908L1198.9 293.009L1198.49 294.127H1196.66L1197.98 288.741L1200.22 284.167V283.964L1202.77 284.269L1203.99 286.81L1201.24 289.35L1200.32 292.908Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="LR"
        d="M955.495 459.892L955.291 461.721L955.8 464.872L954.579 467.82L956.207 469.649L958.04 470.055L960.483 472.8L960.687 475.34L960.076 476.153L959.669 481.54L958.142 481.642L952.237 478.491L946.944 473.511L942.057 469.954L938.189 465.787L939.614 463.653L939.919 461.721L942.566 458.266L945.213 455.217L946.536 455.014L947.962 454.302L950.405 458.266L949.998 460.908L951.117 462.331H952.746L953.866 459.689L955.495 459.892Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="LY"
        d="M1142.81 303.986L1141.08 307.137L1142.09 309.983L1140.97 313.946L1143.01 319.231L1144.33 342.404L1145.35 366.491L1145.86 379.5H1139.35V382.244L1116.34 369.743L1093.43 357.242L1087.83 360.8L1083.97 363.239L1080.71 359.682L1071.75 356.836L1069.21 352.77L1064.62 349.721L1062.08 350.941L1059.94 347.282L1059.74 344.538L1056.28 339.761L1058.52 337.017L1057.91 332.952L1058.52 329.395L1058.11 326.346L1058.92 321.061L1058.52 318.012L1056.58 312.219L1059.23 310.796L1059.64 307.95L1059.03 305.308L1062.69 302.767L1064.32 300.632L1066.97 298.803L1067.07 293.823L1073.58 296.059L1075.92 295.449L1080.51 296.567L1087.94 299.514L1090.79 305.308L1095.78 306.527L1103.72 309.271L1109.82 312.524L1112.37 310.796L1114.91 307.848L1113.28 302.868L1114.81 299.616L1118.58 296.567L1122.34 295.754L1129.88 297.075L1131.91 299.921L1133.95 300.023L1135.78 301.141L1141.28 301.852L1142.81 303.986Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="LS"
        d="M1159.6 709.301L1157.57 710.012L1153.8 704.93L1157.06 700.865L1160.21 698.324L1162.96 696.901L1165.2 698.934L1166.93 700.967L1165 704.117L1163.88 706.252L1160.72 707.268L1159.6 709.301Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="LT"
        d="M1131.1 150.012L1132.12 152.756L1128.45 154.788L1127.94 158.244L1123.06 160.581H1118.27L1116.85 158.65L1114.3 157.939L1113.69 156.414L1113.9 154.687L1111.66 153.772L1106.46 152.654L1104.73 147.471L1109.93 145.641L1117.97 146.048L1122.55 145.438L1123.46 146.658L1126.01 147.064L1131.1 150.012Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="LU"
        d="M1035.2 188.429L1033.78 188.53L1032.66 188.022L1033.07 184.465L1034.39 184.262L1035.41 185.685L1035.2 188.429Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="LV"
        d="M1132.83 138.73L1135.38 140.051L1136.39 142.999L1138.53 146.657L1133.85 148.995L1131.1 150.011L1126.01 147.064L1123.46 146.657L1122.55 145.438L1117.97 146.048L1109.93 145.641L1104.73 147.47L1104.22 142.897L1105.96 139.035L1110.13 137.002L1114.61 141.576L1118.37 141.372L1118.48 136.697L1122.34 135.681L1124.48 136.392L1128.96 138.628L1132.83 138.73Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="MA"
        d="M992.346 280.509L994.281 284.676L994.586 288.639L996.52 295.55L997.946 296.973L996.927 299.514L989.7 300.632L987.155 302.97L983.999 303.579L983.693 308.458L977.178 310.999L975.04 314.251L970.459 315.979L964.962 316.995L955.902 321.873L955.8 329.598H954.884L954.986 333.053L951.525 333.256L949.692 334.781H947.147L945.111 333.866L940.428 334.578L938.494 339.659L936.662 340.168L933.913 348.4L925.871 355.413L923.835 364.458L921.392 367.405L920.679 369.743L907.954 370.251H907.852L908.158 367.202L910.397 365.474L912.332 362.019L912.026 359.783L914.062 355.209L917.32 351.042L919.254 350.026L920.883 346.266L921.086 342.708L923.224 338.745L927.093 336.305L930.757 329.699L930.859 329.598L933.811 327.057L939.003 326.345L943.482 321.873L946.333 320.146L951.117 314.657L949.896 306.628L952.135 300.937L953.052 297.481L956.716 293.111L962.214 290.164L966.387 287.42L970.154 280.712L971.986 276.646L975.957 276.748L979.112 279.492L984.304 279.086L989.903 280.509H992.346Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="MD"
        d="M1149.73 213.736L1148.41 210.788L1148.61 208.044L1148 205.3L1144.54 201.438L1142.5 198.796L1140.67 196.966L1139.04 196.255L1140.16 195.34L1143.42 194.73L1147.49 196.661L1149.53 196.966L1152.17 198.694L1152.07 200.828L1154.11 201.845L1155.23 204.487L1157.26 206.113L1157.06 207.13L1158.08 207.739L1156.75 208.247L1153.7 208.044L1153.09 207.13L1152.07 207.638L1152.68 208.756L1151.56 210.89L1150.95 213.024L1149.73 213.736Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="MX"
        d="M457.388 341.387L459.627 341.184L456.37 346.977L454.537 351.652L452.705 360.393L451.585 363.543L451.992 367.1L453.316 370.353L453.723 375.333L456.777 380.211L457.591 383.972L459.322 387.122L465.124 388.85L467.059 391.594L472.352 389.765L476.73 389.155L481.209 387.935L484.874 386.817L488.844 384.175L490.676 380.414L491.898 374.926L493.119 372.995L497.191 371.267L503.401 369.743L508.389 370.048L511.851 369.438L513.072 370.861L512.461 374.012L508.898 377.874L507.066 381.837L507.982 382.955L506.761 385.801L504.623 390.883L503.401 389.155L502.281 389.257L501.162 389.358L498.617 393.322L497.7 392.509L496.988 392.814L496.886 393.83L491.592 393.728H486.299L485.79 397.387L483.245 397.489L485.077 399.623L487.011 401.148L487.52 402.571L488.335 402.977L487.928 405.213H480.598L477.239 410.498L477.951 411.718L477.137 413.242L476.73 415.173L471.029 408.16L468.382 406.026L463.903 404.298L460.645 404.807L455.759 407.246L452.807 407.856L449.04 406.128L444.866 404.908L439.98 401.961L435.806 401.046L429.8 397.997L425.422 394.846L424.303 393.119L421.147 392.712L415.65 390.679L413.715 387.732L408.218 383.972L405.979 379.906L405.164 376.654L407.098 376.044L406.793 374.215L408.422 372.487L408.829 370.251L407.302 367.304V364.763L405.979 361.409L402.11 354.904L397.427 349.823L395.493 345.757L391.319 343.115L390.607 341.489L392.337 337.525L389.894 336.001L387.349 332.748L387.146 328.276L384.295 327.667L381.954 324.313L380.223 321.06L380.529 319.028L379.002 314.149L378.696 309.169L379.511 306.628L376.355 303.986L374.421 304.291L371.977 302.563L370.145 305.206L370.043 308.255L369.025 313.235L370.043 315.877L372.894 320.349L373.301 321.975L374.013 322.382L374.115 324.618L375.133 324.516V328.785L376.457 330.411L376.966 332.748L379.714 336.001L380.121 342.099L381.139 344.944L382.056 347.993L381.75 351.449L384.397 351.652L386.026 354.6L387.553 357.547L387.247 358.766L384.397 361.104H383.379L382.666 357.14L379.714 353.38L376.253 350.229L373.708 348.603L374.93 343.826L374.828 340.269L372.69 338.236L369.534 335.391L368.618 336.204L367.6 334.476L364.546 332.952L362.306 329.089L362.815 328.683L364.953 328.988L367.702 326.549L368.72 323.601L365.768 318.926L363.121 317.198L362.306 313.133L361.696 308.763L360.881 303.579L360.678 297.685L367.091 297.177L374.319 296.465L373.403 297.786L380.529 300.937L391.625 305.51H402.619H406.997L407.811 302.766H417.38L418.704 305.104L420.841 307.238L423.285 310.084L424.099 313.438L424.506 317.097L426.848 319.028L430.92 320.959L435.806 315.877L440.387 315.674L443.645 318.316L445.273 322.788L446.19 326.65L448.633 330.309L448.836 334.883L449.753 337.932L453.723 339.964L457.388 341.387Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="MK"
        d="M1125.4 240.465L1124.38 240.669L1123.57 241.787L1120.72 241.685L1118.88 243.108L1115.42 243.616L1113.08 242.092L1112.06 239.347L1112.57 237.112L1113.28 237.213L1113.39 235.892L1116.34 234.876L1117.56 234.571L1119.29 234.266L1121.73 234.062L1124.58 236.197L1125.4 240.465Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="ML"
        d="M1028.38 384.988L1028.49 400.03L1025.33 404.4L1024.92 408.466L1019.83 409.482L1011.99 409.99L1009.96 412.328L1006.29 412.633H1002.63L1001.2 411.413L998.047 412.328L992.652 415.072L991.532 417.104L987.155 419.95L986.34 421.678L983.897 422.999L981.148 422.084L979.621 423.711L978.705 428.182L974.124 433.569L974.328 435.805L972.699 438.549L973.106 442.31L970.663 443.326L969.34 444.139L968.423 441.395L966.795 442.106L965.777 442.005L964.759 443.834H960.279L958.752 442.818L957.938 443.427L956.207 441.496L956.513 439.565L955.8 438.854L954.579 439.464L954.884 437.329L956.004 435.703L953.662 432.959L953.052 431.13L951.728 429.707L950.608 429.504L949.285 430.418L947.351 431.333L945.824 432.756L943.381 432.248L941.752 430.52L940.836 430.317L939.309 431.231H938.392L938.087 428.792L938.392 426.76L937.883 424.32L935.847 422.491L934.728 418.731L934.524 414.665L936.458 413.446L937.476 409.584L939.309 409.482L943.279 411.311L946.536 409.99L948.674 410.397L949.59 408.974L972.495 408.872L973.819 404.299L972.801 403.485L970.256 375.333L967.813 347.18L976.466 347.079L995.4 361.308L1014.44 375.536L1015.76 378.585L1019.32 380.415L1021.97 381.533L1022.07 385.7L1028.38 384.988Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="ME"
        d="M1110.23 230.911L1109.42 232.334L1107.99 232.944L1107.58 231.724L1105.65 234.875L1106.16 237.009L1105.04 236.501L1103.31 234.367L1100.97 233.046L1101.48 232.029L1101.88 228.472L1103.51 226.948L1104.43 226.338L1105.85 227.456L1106.77 228.371L1108.5 229.082L1110.64 230.403L1110.23 230.911Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="MZ"
        d="M1187.7 684.503H1183.53L1183.22 681.555L1182.61 678.608L1182.2 676.27L1183.63 669.054L1182.51 664.379L1180.27 655.232L1186.58 647.813L1188.31 643.138L1189.13 642.528L1190.04 638.666L1189.23 636.735L1189.63 631.857L1190.96 627.385L1191.37 619.051L1188.51 617.018L1185.77 616.51L1184.65 614.884L1182 613.562L1177.22 613.664L1177.01 611.225L1176.6 606.55L1194.11 601.163L1197.37 604.314L1198.9 603.704L1201.14 605.33L1201.34 607.973L1200.02 611.022L1200.22 615.595L1203.79 619.66L1205.72 615.087L1208.26 613.766L1208.16 605.33L1205.92 600.655L1203.99 598.521H1203.58L1202.97 591.101L1204.5 584.902L1206.74 584.698L1213.56 586.528L1215.08 585.715L1219.06 585.512L1221.19 583.581L1224.65 583.682L1230.97 581.141L1235.65 577.381L1236.56 580.227L1236.06 586.731L1236.56 592.524L1236.36 602.688L1237.18 605.838L1235.24 610.513L1232.8 615.087L1229.03 619.152L1223.64 621.591L1217.02 624.742L1210.3 631.755L1208.06 632.974L1203.79 637.65L1201.44 639.072L1200.63 643.748L1203.07 648.728L1203.99 652.488V654.521L1205.01 654.114L1204.5 660.517L1203.38 663.566L1204.6 664.684L1203.58 667.428L1201.14 669.766L1196.35 671.9L1189.33 675.457L1186.78 677.897L1187.09 680.641L1188.41 681.047L1187.7 684.503Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="MR"
        d="M976.466 347.078L967.813 347.18L970.256 375.333L972.801 403.485L973.819 404.298L972.495 408.872L949.59 408.973L948.674 410.396L946.536 409.99L943.279 411.311L939.309 409.482L937.476 409.583L936.458 413.445L934.524 414.665L930.859 410.193L927.398 405.315L923.733 403.587L920.985 401.757H917.829L914.978 403.18L912.23 402.672L910.194 404.705L909.787 401.249L911.415 397.997L912.23 391.899L911.823 385.394L911.212 382.142L911.823 378.89L910.397 375.841L907.547 372.995L908.87 370.861H930.961L930.045 361.409L931.572 358.055L936.865 357.547L937.069 340.777L955.393 341.184L955.597 331.224L976.466 347.078Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="MW"
        d="M1203.58 598.521H1203.99L1205.92 600.655L1208.16 605.33L1208.26 613.766L1205.72 615.087L1203.78 619.66L1200.22 615.595L1200.02 611.021L1201.34 607.972L1201.14 605.33L1198.9 603.704L1197.37 604.314L1194.11 601.163L1191.16 599.537L1193.2 593.439L1195.03 591.203L1194.11 585.715L1195.44 580.43L1196.46 578.702L1195.13 573.214L1192.49 570.266L1198.08 571.486L1199.1 573.214L1199 574.027L1200.83 578.194L1201.04 586.02L1199.2 589.678L1200.83 594.455L1200.63 597.301L1201.85 599.232L1201.75 601.671L1202.67 603.094L1203.68 601.468L1205.62 604.009L1205.82 603.196L1204.8 599.74L1203.68 599.435L1203.58 598.521Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="NA"
        d="M1136.29 624.335L1140.97 622.913L1144.64 623.217L1146.88 624.742V625.25L1143.62 626.775H1141.89L1138.12 629.315L1136.09 626.571L1127.23 628.909L1122.96 629.112L1122.14 652.386L1116.54 652.59L1115.93 671.595L1114.81 695.682L1109.72 699.036L1106.77 699.544L1103.31 698.325L1100.76 697.816L1099.95 695.072L1097.91 693.243L1095.06 696.495L1091.09 691.515L1089.06 686.84L1088.04 680.437L1086.82 675.762L1085.19 665.7L1085.29 657.874L1084.68 654.317L1082.54 651.573L1079.69 646.187L1076.84 638.361L1075.72 634.295L1071.24 627.893L1070.94 622.913L1073.68 621.693L1077.15 620.575L1080.81 620.778L1084.17 623.726L1084.98 623.217L1108.09 623.014L1111.96 626.063L1125.7 626.978L1136.29 624.335Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="NE"
        d="M1087.83 360.8L1089.46 370.963L1091.7 372.691L1091.81 374.723L1094.25 376.959L1093.03 379.805L1091.19 393.017L1090.99 401.555L1083.86 407.653L1081.52 416.292L1083.97 418.731V422.898L1087.73 422.999L1087.12 426.15L1085.6 426.455L1085.39 428.589L1084.37 428.691L1080.4 421.576L1078.98 421.272L1074.6 424.93L1070.12 422.999L1067.07 422.694L1065.44 423.609L1062.08 423.406L1058.72 426.15L1055.77 426.353L1048.85 422.999L1046.1 424.524L1043.14 424.422L1041.01 421.983L1035.31 419.544L1029.1 420.357L1027.67 421.678L1026.86 425.439L1025.23 428.081L1024.82 433.976L1020.44 430.215H1018.41L1016.47 432.146L1016.57 427.675L1009.96 426.15L1009.75 422.999L1006.6 418.731L1005.78 415.783L1006.29 412.633L1009.96 412.328L1011.99 409.99L1019.83 409.482L1024.92 408.466L1025.33 404.4L1028.49 400.03L1028.38 384.988L1036.32 382.143L1052.61 369.337L1071.75 356.836L1080.71 359.682L1083.97 363.239L1087.83 360.8Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="NG"
        d="M1085.39 428.589L1087.73 431.13L1087.12 432.35L1086.82 434.484L1082.03 439.566L1080.61 443.732L1079.79 447.086L1078.57 448.611L1077.45 453.184L1074.4 455.827L1073.58 459.079L1072.26 461.722L1071.75 464.466L1067.78 466.702L1064.52 463.958L1062.38 464.059L1058.92 467.921H1057.29L1054.55 474.223L1053.12 478.898L1047.11 481.235L1044.98 480.93L1042.74 482.353L1038.16 482.252L1035 478.085L1033.07 473.409L1028.99 469.141H1024.72H1019.63L1019.93 458.673L1019.73 454.506L1020.85 450.44L1022.58 448.408L1025.43 444.342L1024.82 442.615L1025.94 439.972L1024.62 436.11L1024.82 433.976L1025.23 428.081L1026.86 425.438L1027.67 421.678L1029.1 420.357L1035.31 419.544L1041.01 421.983L1043.14 424.422L1046.1 424.524L1048.85 422.999L1055.77 426.353L1058.72 426.15L1062.08 423.406L1065.44 423.609L1067.07 422.694L1070.12 422.999L1074.6 424.93L1078.98 421.271L1080.4 421.576L1084.37 428.691L1085.39 428.589Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="NI"
        d="M528.953 412.124L528.444 412.836L527.935 414.258L528.342 416.596L526.815 418.832L526.001 421.474L525.492 424.32L525.695 426.048L525.593 428.995L524.677 429.605L523.965 432.451L524.168 434.179L522.947 435.805L523.048 437.532L523.863 438.65L522.438 440.073L520.707 439.565L519.893 438.244L518.06 437.736L516.737 438.549L513.072 436.821L512.156 437.634L510.323 435.601L507.778 432.959L506.659 430.825L504.419 428.69L501.874 425.743L502.587 424.727L503.401 425.743L503.91 425.336L505.742 425.032L506.557 423.507H507.371L507.575 420.255L508.898 420.153H510.12L511.545 418.425L513.072 419.747L513.683 418.934L514.904 418.12L517.042 416.393L517.246 414.97L517.755 415.071L518.671 413.547L519.282 413.344L520.198 414.36L521.318 414.563L522.641 413.75H524.066L526.102 412.937L527.019 412.022L528.953 412.124Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_46"
        d="M1133.75 68.6029L1127.23 70.7372L1123.97 71.2453L1124.79 67.3833L1118.88 65.249L1112.88 67.0784L1111.76 71.1437L1108.3 73.5829L1103.51 72.2617L1098.12 72.4649L1092.92 69.6192L1090.69 71.0421L1088.04 71.2453L1088.14 74.9041L1080 73.9894L1079.39 77.1401H1075.31L1072.97 81.1038L1069.51 87.3034L1063.71 95.3325L1065.54 97.3652L1064.22 99.6011L1059.84 99.4995L1057.4 104.988L1058.41 112.813L1061.57 115.761L1060.76 122.774L1057.29 126.839L1055.46 130.294L1052.1 126.636L1043.35 133.547L1037.14 134.97L1030.52 131.921L1028.69 125.518L1026.65 111.797L1030.72 108.037L1042.23 103.057L1050.47 97.0603L1057.8 89.1328L1066.86 78.2581L1073.38 74.0911L1083.86 67.18L1092.52 64.7408L1099.34 65.0457L1104.63 60.5738L1112.17 60.7771L1119.29 59.7607L1133.24 63.7245L1128.25 65.1473L1133.75 68.6029Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_47"
        d="M1095.98 25.6114L1088.24 27.5424L1081.32 26.4244L1083.56 25.2048L1080.91 23.6803L1088.34 22.7656L1090.28 24.4934L1095.98 25.6114Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_48"
        d="M1069.92 16.9727L1082.74 20.4283L1073.99 22.2577L1072.77 25.7132L1069.71 26.6279L1068.8 30.6933L1064.32 30.8965L1055.67 27.9492L1058.72 26.2214L1052.92 24.7985L1045.08 20.8348L1041.82 17.2776L1051.29 15.6515L1053.63 17.176H1058.72L1059.74 15.6515L1065.03 15.4482L1069.92 16.9727Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_49"
        d="M1094.76 13.9241L1102.29 15.4486L1097.81 17.8878L1087.53 18.396L1076.64 17.5829L1075.62 16.3633H1070.43L1066.05 14.3307L1076.74 13.1111L1082.24 14.1274L1085.39 12.8062L1094.76 13.9241Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="PA"
        d="M559.187 453.489L558.475 454.404L559.595 458.266L558.475 460.197L556.642 459.689L555.726 462.84L553.894 461.01L552.876 457.453L554.301 455.725L552.876 455.319L551.96 453.185L549.109 451.355L546.666 451.762L545.343 453.998L542.899 455.624L541.678 455.827L541.067 457.25L543.612 460.807L541.983 461.62L541.169 462.535L538.42 462.941L537.606 458.978L536.791 460.096L534.959 459.689L533.941 457.148L531.6 456.64L530.073 455.929H527.629L527.426 457.352L526.815 456.335L527.12 455.014L527.731 453.693L527.528 452.575L528.444 451.762L527.324 450.847L527.426 448.204L529.665 447.595L531.6 449.932L531.396 451.355L533.636 451.66L534.246 451.05L535.773 452.676L538.624 452.168L541.169 450.542L544.732 449.221L546.768 447.29L549.924 447.696L549.72 448.306L552.876 448.509L555.319 449.729L557.151 451.66L559.187 453.489Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="PE"
        d="M601.129 538.048L595.937 537.743L595.123 538.76L590.44 539.979L584.027 544.451L583.721 547.5L582.296 549.736L583.009 553.293L579.548 555.123L579.751 557.968L578.224 559.086L580.871 564.981L584.23 568.945L583.212 571.79L587.081 572.095L589.422 575.653L594.512 575.754L598.991 571.994L599.093 581.852L601.74 582.564L604.998 581.446L610.597 592.016L609.477 594.15V598.825L609.782 604.313L607.848 607.565L609.07 610.005L607.95 612.241L610.902 617.729L607.95 624.742L606.83 628.095L603.98 629.722L597.973 625.961L597.159 623.319L585.248 616.814L574.356 609.598L569.571 605.634L566.721 600.248L567.535 598.317L562.038 589.78L555.523 577.787L549.415 564.778L546.972 561.729L544.936 556.952L540.253 552.683L536.079 550.041L537.809 547.195L534.755 540.894L536.486 536.32L540.965 532.255L541.678 534.999L540.049 536.524L540.355 538.861L542.696 538.353L545.037 539.064L547.582 542.418L550.738 539.674L551.654 535.304L555.116 529.613L561.936 527.072L568.146 520.161L569.877 515.994L569.062 511.014L570.589 510.404L574.458 513.453L576.29 516.603L578.937 518.23L582.5 525.039L586.775 525.954L589.931 524.226L592.069 525.344L595.53 524.734L600.009 527.783L596.446 534.491L598.177 534.593L601.129 538.048Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="PL"
        d="M1099.34 157.329L1105.34 158.04L1114.3 157.939L1116.85 158.65L1118.27 160.581L1118.88 163.325L1120.61 165.663L1121.02 168.102L1118.17 169.423L1120.11 172.269L1120.61 175.115L1123.87 180.603L1123.57 182.331L1121.23 183.042L1117.36 188.327L1118.99 191.173L1117.87 190.766L1112.78 188.327L1109.21 189.242L1106.77 188.632L1103.92 189.953L1101.17 187.717L1099.24 188.632L1098.93 188.226L1096.28 185.075L1092.52 184.77L1091.81 182.737L1088.34 182.026L1087.73 183.652L1084.88 182.331L1085.09 180.603L1081.32 180.095L1078.77 178.062L1076.33 174.098L1076.54 171.863L1075.01 168.509L1073.07 166.374L1074.3 164.647L1072.87 161.496L1076.03 159.667L1083.25 156.821L1089.16 154.788L1094.04 155.804L1094.66 157.329H1099.34Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="PY"
        d="M674.425 641.715L676.461 645.272L676.868 654.114L682.874 655.435L685.114 654.114L689.084 655.943L690.306 657.874L691.425 663.871L692.24 666.31L694.378 666.615L696.414 665.598L698.551 666.716L698.857 670.375L698.551 674.237L697.839 677.998L697.533 683.689L693.156 688.771L688.88 689.787L682.467 688.771L676.563 687.043L680.838 677.083L679.718 674.237L673.712 671.696L666.281 666.818L661.598 665.802L650.095 655.232L651.622 647.406L651.418 643.849L653.556 638.157L663.329 636.226L668.622 636.328L674.119 639.682L674.425 641.715Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="PS"
        d="M1199.51 298.599L1199.92 302.665L1199.31 304.596L1196.76 305.409L1196.86 303.681L1198.19 302.766L1196.66 302.055L1197.37 297.786L1199.51 298.599Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="RO"
        d="M1139.04 196.255L1140.67 196.966L1142.5 198.796L1144.54 201.438L1148 205.3L1148.61 208.044L1148.41 210.788L1149.73 213.736L1152.17 214.955L1154.51 213.837L1156.96 214.955L1157.36 216.683L1155.02 218.004L1153.39 217.395L1152.99 225.22L1149.83 224.509L1145.76 222.171L1139.75 223.696L1137.41 225.322L1129.67 224.916L1125.6 224.001L1123.67 224.407L1121.84 221.765L1120.82 220.647L1121.84 219.529L1120.51 218.818L1118.99 220.24L1115.83 218.309L1115.12 215.667L1111.86 214.244L1111.05 212.11L1107.99 209.671L1111.96 208.451L1114.61 204.081L1116.54 199.812L1119.49 198.491L1121.53 197.068L1124.79 197.779H1128.05L1130.59 199.406L1132.22 198.389L1135.88 197.779L1136.9 196.255H1139.04Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="RW"
        d="M1179.66 517.417L1181.9 521.076L1181.59 524.938L1179.96 525.751L1176.81 525.344L1175.08 529.105L1171.51 528.597L1172.13 524.938L1172.94 524.43L1173.14 520.568L1174.77 518.738L1176.2 519.45L1179.66 517.417Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="EH"
        d="M955.8 329.598L955.698 330.004L955.597 331.224L955.393 341.184L937.069 340.778L936.865 357.547L931.572 358.055L930.045 361.409L930.961 370.861H908.87L907.547 372.995L907.852 370.251H907.954L920.679 369.743L921.392 367.406L923.835 364.458L925.871 355.413L933.913 348.4L936.662 340.168L938.494 339.66L940.428 334.578L945.111 333.867L947.147 334.781H949.692L951.525 333.257L954.986 333.053L954.884 329.598H955.8Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="SD"
        d="M1212.44 415.885L1211.73 421.475L1209.69 427.979L1206.33 431.13L1203.99 436.212L1203.48 438.854L1200.83 440.684L1199.31 447.493V448.306L1198.49 448.103L1198.59 444.851L1197.78 442.615L1194.83 440.074L1193.91 435.399L1194.52 430.52L1191.87 430.114L1191.47 431.537L1188.01 431.943L1189.53 433.772L1190.04 437.736L1186.99 441.293L1184.24 445.968L1181.29 446.68L1176.4 442.919L1174.26 444.241L1173.75 446.07L1170.8 447.391L1170.6 448.713H1164.9L1164.08 447.391L1159.91 447.086L1157.87 448.204L1156.24 447.696L1153.29 443.834L1152.27 442.106L1148.1 443.021L1146.57 445.968L1145.25 451.863L1143.21 453.083L1141.48 453.794L1140.97 453.489L1139.04 451.558L1138.63 449.526L1139.45 446.883V444.139L1136.09 440.074L1135.38 437.33V435.703L1133.24 433.772L1133.14 430.012L1131.81 427.471L1129.88 427.878L1130.39 425.438L1131.81 422.796L1131.1 420.052L1132.93 418.019L1131.71 416.495L1133.03 412.531L1135.58 407.653L1140.47 408.161L1139.35 382.244V379.5H1145.86L1145.35 366.491H1168.05H1189.94H1212.44L1214.58 372.894L1213.35 374.012L1214.58 380.821L1217.12 388.545L1219.36 390.172L1222.62 392.611L1219.87 396.27L1215.8 397.388L1214.07 399.42L1213.76 403.689L1211.73 413.344L1212.44 415.885Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="SS"
        d="M1199.31 448.306L1199.51 453.387L1198.7 455.318L1195.64 455.522L1193.71 459.18L1197.27 459.689L1200.32 462.839L1201.34 465.482L1203.99 467.006L1207.55 474.121L1203.68 478.389L1200.22 482.251L1196.66 485.3H1192.59L1188.01 486.825L1184.34 485.3L1182 487.13L1176.81 482.759L1175.38 480.015L1172.23 481.337L1169.58 480.93L1168.05 482.048L1165.41 481.235L1161.84 475.848L1160.93 473.816L1156.55 471.173L1155.12 467.311L1152.68 464.465L1148.71 461.112L1148.61 458.977L1145.45 456.335L1141.48 453.794L1143.21 453.082L1145.25 451.863L1146.57 445.968L1148.1 443.021L1152.27 442.106L1153.29 443.834L1156.24 447.696L1157.87 448.204L1159.91 447.086L1164.08 447.391L1164.9 448.712H1170.6L1170.8 447.391L1173.75 446.07L1174.26 444.24L1176.4 442.919L1181.29 446.68L1184.24 445.968L1186.99 441.293L1190.04 437.736L1189.53 433.772L1188.01 431.943L1191.47 431.536L1191.87 430.113L1194.52 430.52L1193.91 435.398L1194.83 440.073L1197.78 442.614L1198.59 444.85L1198.49 448.102L1199.31 448.306Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="SN"
        d="M934.524 414.665L934.728 418.731L935.847 422.491L937.883 424.32L938.392 426.76L938.087 428.792L937.273 429.199L934.117 428.691L933.71 429.402L932.488 429.504L928.314 427.979L925.566 427.878L914.978 427.573L913.451 428.386L911.517 428.183L908.463 429.199L907.649 424.219L912.841 424.32L914.266 423.406H915.284L917.422 421.881L919.865 423.202L922.308 423.406L924.853 421.881L923.733 420.052L921.799 421.068H920.068L917.829 419.442L915.996 419.544L914.673 421.17L908.463 421.271L906.122 416.19L903.373 413.954L905.918 412.633L908.769 408.059L910.194 404.705L912.23 402.673L914.978 403.181L917.829 401.758H920.985L923.733 403.587L927.398 405.315L930.859 410.193L934.524 414.665Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="SL"
        d="M945.213 455.217L942.566 458.266L939.919 461.722L939.614 463.653L938.189 465.787L936.662 465.279L932.59 462.636L929.536 459.181L928.62 456.742L927.907 451.965L931.063 449.017L931.674 447.29L932.692 445.867L934.32 445.663L935.644 444.444H940.225L941.854 446.781L943.075 449.526L942.872 451.457L943.788 453.184L943.686 455.522L945.213 455.217Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="SV"
        d="M501.365 422.694L500.653 424.219L497.293 424.117L495.257 423.507L493.018 422.186L489.964 421.78L488.437 420.357L488.742 419.442L490.778 417.816L492 417.104L491.694 416.291L493.119 415.885L494.748 416.495L495.868 417.714L497.497 418.832L497.599 419.645L500.144 418.934L501.365 419.34L502.078 420.052L501.365 422.694Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="RS"
        d="M1121.84 221.765L1120.72 223.187L1121.43 225.627L1124.28 228.371L1122.45 230.403L1121.84 232.436L1122.45 233.249L1121.73 234.062L1119.29 234.265L1117.56 234.57L1117.26 234.062L1117.87 233.351L1118.27 231.725L1117.56 231.826L1116.44 230.607L1115.52 230.302L1114.71 229.285L1113.69 228.879L1112.88 227.964L1111.96 228.371L1111.45 230.505L1110.23 230.912L1110.64 230.403L1108.5 229.082L1106.77 228.371L1105.85 227.456L1104.43 226.338L1105.55 226.033L1106.06 223.086L1103.31 220.545L1104.43 217.699L1102.49 217.801L1104.22 215.362L1102.49 213.532L1100.97 210.991L1104.73 209.365L1107.99 209.67L1111.05 212.109L1111.86 214.244L1115.12 215.667L1115.83 218.309L1118.99 220.24L1120.51 218.817L1121.84 219.529L1120.82 220.647L1121.84 221.765Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="SR"
        d="M693.258 472.495L690.102 478.085L690.407 482.557L692.647 486.419L691.527 489.163L691.018 492.212L689.491 494.956L686.234 493.533L683.485 494.244L681.144 493.635L680.533 495.566L681.551 496.785L680.94 498.208L677.784 497.598L674.425 491.907L673.712 488.248H671.88L669.437 483.573L670.557 480.117L670.251 478.593L673.814 476.967L674.832 471.072L681.755 472.393L682.365 471.174L687.048 470.666L693.258 472.495Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="SK"
        d="M1117.87 190.766L1116.64 192.494L1115.93 195.035L1114.91 195.644L1109.31 193.713L1107.69 194.12L1106.67 195.644L1104.33 196.458L1103.72 196.051L1101.37 196.966L1099.44 197.169L1099.13 198.49L1094.96 199.202L1093.03 198.592L1090.28 196.864L1089.57 194.73L1089.87 193.917L1090.48 192.494L1092.72 192.595L1094.35 191.986L1094.45 191.376L1095.37 191.071L1095.57 189.648L1096.69 189.343L1097.4 188.225H1098.93L1099.24 188.632L1101.17 187.717L1103.92 189.953L1106.77 188.632L1109.21 189.242L1112.78 188.327L1117.87 190.766Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="SI"
        d="M1089.06 207.231L1085.09 208.959L1084.78 211.499L1083.05 212.211L1083.15 213.939L1081.12 213.837L1079.28 212.821L1078.47 213.837L1074.8 213.634L1075.92 213.126L1074.5 210.381L1074.91 207.231L1079.18 207.739L1081.63 206.214L1086.1 206.113L1087.02 204.995L1087.83 205.097L1089.06 207.231Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="SE"
        d="M1107.79 88.4211L1100.66 90.0472L1097.1 94.0109L1098.42 97.5681L1092.11 102.142L1084.17 107.223L1082.03 115.456L1085.8 119.623L1090.69 122.976L1087.33 129.684L1082.64 131.107L1082.03 141.271L1079.89 147.064L1074.09 146.454L1071.85 151.332L1066.25 151.637L1064.32 145.844L1059.74 138.831L1055.46 130.294L1057.29 126.839L1060.76 122.773L1061.57 115.761L1058.41 112.813L1057.4 104.987L1059.84 99.4991L1064.22 99.6008L1065.54 97.3648L1063.71 95.3322L1069.51 87.3031L1072.97 81.1035L1075.31 77.1398H1079.39L1080 73.9891L1088.14 74.9038L1088.04 71.245L1090.69 71.0417L1096.79 73.7859L1104.12 77.5463L1105.96 86.1852L1107.79 88.4211Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="SZ"
        d="M1182.61 678.608L1183.22 681.555L1183.53 684.503L1182.1 687.348L1178.84 688.06L1175.69 684.503L1175.79 682.267L1177.52 679.827L1178.13 677.896L1179.86 677.49L1182.61 678.608Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="SY"
        d="M1216.51 292.197L1206.64 299.209L1200.22 296.567H1200.12L1200.73 295.551L1200.32 292.908L1201.24 289.351L1203.99 286.81L1202.77 284.269L1200.22 283.964L1199.1 278.984L1200.12 276.24L1201.44 274.817L1202.67 273.395L1202.46 269.837L1204.4 271.057L1210.1 269.228L1213.15 270.447H1217.63L1223.43 268.008L1226.38 268.11L1232.39 267.093L1230.25 271.159L1227.5 272.785L1228.73 277.562L1227.71 285.387L1216.51 292.197Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="TD"
        d="M1139.35 382.244L1140.47 408.16L1135.58 407.652L1133.03 412.531L1131.71 416.494L1132.93 418.019L1131.1 420.052L1131.81 422.796L1130.39 425.438L1129.88 427.877L1131.81 427.471L1133.14 430.012L1133.24 433.772L1135.38 435.703V437.329L1131.71 438.447L1128.86 441.09L1124.79 448.204L1119.49 451.253L1113.9 450.847L1112.27 451.456L1112.88 453.692L1109.93 456.03L1107.48 458.571L1100.25 461.01L1098.83 459.587L1097.81 459.384L1096.79 461.112L1092.11 461.62L1092.92 459.79L1091.09 455.318L1090.28 452.676L1087.73 451.558L1084.27 447.696L1085.49 444.647L1088.14 445.257L1089.77 444.85H1093.03L1089.77 438.955L1089.97 434.585L1089.46 430.317L1087.12 426.15L1087.73 422.999L1083.97 422.897V418.73L1081.52 416.291L1083.86 407.652L1090.99 401.554L1091.19 393.017L1093.03 379.805L1094.25 376.959L1091.8 374.723L1091.7 372.69L1089.46 370.962L1087.83 360.799L1093.43 357.242L1116.34 369.743L1139.35 382.244Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="TG"
        d="M1009.25 438.244L1008.53 441.7L1010.26 443.631L1012.3 445.867L1012.5 449.119L1013.72 450.441L1013.42 465.482L1014.84 469.954L1010.26 471.377L1008.94 469.039L1007.41 464.872L1006.9 461.62L1008.23 455.827L1006.8 453.388L1006.19 448.306V443.529L1003.85 440.175L1004.26 438.143L1009.25 438.244Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="TN"
        d="M1067.07 293.823L1066.97 298.803L1064.32 300.632L1062.69 302.767L1059.03 305.307L1059.64 307.95L1059.23 310.796L1056.58 312.219L1053.94 300.531L1050.47 297.888L1050.37 296.364L1045.79 292.4L1045.18 287.522L1048.44 283.863L1049.56 278.476L1048.54 272.277L1049.56 268.923L1055.36 266.382L1059.13 267.093V270.447L1063.61 268.008L1064.01 269.228L1061.47 272.48L1061.57 275.427L1063.5 277.053L1063 282.745L1059.43 285.997L1060.65 289.554L1063.5 289.656L1064.93 292.807L1067.07 293.823Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_50"
        d="M1223.33 239.144L1228.93 238.839L1234.63 242.091L1235.95 244.327L1236.06 247.478L1240.33 249.104L1242.77 250.934L1239.42 252.865L1242.37 260.284L1241.65 262.317L1245.52 267.5L1243.08 268.618L1240.94 266.992L1234.53 266.077L1232.39 267.093L1226.38 268.11L1223.43 268.008L1217.63 270.447H1213.15L1210.1 269.228L1204.4 271.057L1202.46 269.837L1202.67 273.395L1201.44 274.818L1200.12 276.24L1197.78 273.293L1199.51 270.854L1196.25 271.464L1191.57 269.939L1188.31 273.7L1180.17 274.411L1175.38 270.955L1169.58 270.752L1168.56 273.395L1164.9 274.208L1159.4 270.752L1153.5 270.854L1149.63 264.349L1145.35 260.792L1147.39 255.71L1143.72 252.56L1148.91 246.36L1157.06 246.157L1158.69 241.177L1168.87 242.091L1174.57 237.925L1180.47 236.095L1189.13 235.892L1199.1 240.465L1207.14 243.006L1213.05 241.99L1217.73 242.6L1223.33 239.144Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_51"
        d="M1142.09 243.819L1143.32 243.108L1144.44 239.042L1141.69 237.314L1146.78 235.282L1151.46 236.095L1152.38 238.636L1157.26 240.668L1156.55 242.294L1150.24 242.599L1148.2 244.632L1144.23 248.088L1142.2 245.14L1142.09 243.819Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="TZ"
        d="M1188.01 516.705L1187.8 520.669L1186.68 525.243L1188.31 527.783L1190.86 526.259L1194.22 525.852L1194.93 526.666L1198.29 525.039L1195.95 522.803L1197.88 519.856L1200.73 516.909L1221.6 530.223L1221.91 533.983L1230.15 540.488L1227.3 548.618L1227.61 552.277L1231.17 554.615L1231.37 556.343L1229.64 560.306L1229.95 562.237L1229.54 565.388L1231.37 569.453L1233.61 575.958L1235.65 577.381L1230.97 581.141L1224.65 583.682L1221.19 583.58L1219.06 585.511L1215.08 585.715L1213.56 586.528L1206.74 584.698L1204.5 584.902L1204.6 584.8L1202.77 582.361L1202.46 575.45L1199.51 571.994L1199.1 573.214L1198.08 571.486L1192.49 570.266L1189.23 568.335L1185.56 567.217L1183.32 566.099L1183.02 565.896L1180.27 559.188L1179.86 555.225L1175.28 550.753L1176.71 548.313L1175.59 545.671L1175.79 542.927L1174.77 542.012L1175.08 539.166L1175.69 539.065L1177.72 536.727L1180.07 533.272L1181.49 531.95V529.816L1180.27 528.292L1179.96 525.751L1181.59 524.938L1181.9 521.076L1179.66 517.417L1181.69 516.604L1188.01 516.705Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="UG"
        d="M1200.22 482.251L1202.97 486.825L1203.68 490.077L1206.33 497.598L1204.19 502.375L1201.34 506.643L1199.71 509.286V509.591L1199.51 509.184L1196.46 507.863L1194.01 509.489L1190.35 510.404L1187.7 514.164L1188.01 516.705L1181.69 516.604L1179.66 517.417L1176.2 519.449L1174.77 518.738L1174.87 513.859L1176.2 511.319L1176.5 506.135L1177.72 503.086L1179.96 499.732L1182.1 497.903L1184.04 495.667L1181.69 494.752L1182 487.13L1184.34 485.3L1188.01 486.825L1192.59 485.3H1196.66L1200.22 482.251Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="UA"
        d="M1178.03 177.452L1180.37 180.197L1180.47 181.416L1187.29 183.652L1190.96 182.636L1194.62 185.583L1197.58 185.482L1205.41 187.514L1205.82 189.445L1204.5 192.698L1206.33 196.255L1206.02 198.389L1201.14 198.796L1198.9 200.625L1199.31 203.369L1195.34 203.877L1192.28 206.012L1187.6 206.316L1183.53 208.756L1184.54 212.719L1187.4 214.244L1192.59 213.837L1191.98 216.175L1186.48 217.293L1180.07 220.952L1176.91 219.63L1177.62 216.683L1171.62 214.752L1172.33 213.532L1177.01 211.398L1175.28 209.975L1167.04 208.349L1166.22 205.91L1161.64 206.723L1160.32 210.28L1156.96 214.955L1154.51 213.837L1152.17 214.955L1149.73 213.736L1150.95 213.024L1151.56 210.89L1152.68 208.756L1152.07 207.638L1153.09 207.13L1153.7 208.044L1156.75 208.247L1158.08 207.739L1157.06 207.13L1157.26 206.113L1155.23 204.487L1154.11 201.845L1152.07 200.828L1152.17 198.694L1149.53 196.966L1147.49 196.661L1143.42 194.73L1140.16 195.34L1139.04 196.255H1136.9L1135.88 197.779L1132.22 198.389L1130.59 199.405L1128.05 197.779H1124.79L1121.53 197.068L1119.49 198.491L1118.99 196.763L1115.93 195.035L1116.64 192.494L1117.87 190.766L1118.99 191.173L1117.36 188.327L1121.23 183.042L1123.57 182.331L1123.87 180.603L1120.61 175.115L1122.96 174.81L1125.4 173.184L1129.27 172.981L1134.26 173.489L1140.06 175.013L1144.03 175.115L1145.96 176.03L1147.69 174.912L1149.22 176.436L1153.6 176.131L1155.74 176.741L1155.43 173.59L1156.75 172.168L1160.93 171.863L1162.76 172.066L1163.78 170.643L1165.3 170.948L1170.29 170.338L1174.16 173.895L1173.24 175.217L1174.06 177.148L1178.03 177.452Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="UY"
        d="M712.295 730.339L710.666 734.506L705.169 738.064L700.893 736.742L698.043 737.454L692.444 734.71L688.779 734.913L684.809 731.254L684.401 727.087L685.318 725.664L684.096 719.16L684.503 712.452L685.012 707.167L688.473 706.456L694.887 711.537L696.821 711.334L703.234 715.501L708.121 719.16L711.989 723.53L710.157 726.681L712.295 730.339Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="VE"
        d="M660.377 455.42L655.592 459.282L655.083 461.62L656.915 464.059L655.49 465.279L651.927 466.295V469.344L650.298 471.173L654.065 476.052L654.778 477.881L652.64 480.422L646.125 482.861L641.951 483.878L640.22 485.402L635.639 483.776L631.465 482.963L630.346 483.573L632.891 485.199L632.585 489.569L633.298 493.736L638.184 494.244L638.49 495.667L634.316 497.497L633.603 500.241L631.16 501.359L626.884 502.883L625.765 504.916L621.285 505.322L618.13 501.867L616.501 495.362L614.974 493.025L612.938 491.602L615.89 488.349L615.686 486.927L614.159 484.996L613.04 480.625L613.65 475.95L614.974 473.714L616.195 470.259L614.159 469.141L610.902 469.852L606.728 469.547L604.387 470.259L600.518 464.567L597.159 463.754L589.727 464.364L588.506 462.128L587.081 461.62L586.979 460.197L587.691 457.758L587.386 455.217L586.164 453.692L585.554 450.745L582.601 450.339L584.434 446.476L585.35 441.801L587.182 439.362L589.524 437.533L591.153 434.28L594.919 433.162L594.716 434.687L591.254 435.5L592.985 438.447L592.68 441.903L589.931 445.663L591.865 450.847L594.41 450.44L595.937 445.663L594.207 443.427V438.447L601.536 435.805L600.925 432.756L603.063 430.622L604.794 435.297L608.866 435.398L612.327 438.956L612.531 441.191H617.621L623.83 440.582L626.986 443.427L631.262 444.24L634.621 442.208L634.723 440.582L641.951 440.175L648.771 440.074L643.783 442.005L645.616 445.155L650.197 445.562L654.472 448.814L655.185 453.997L658.137 453.896L660.377 455.42Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="ZM"
        d="M1183.02 565.896L1183.32 566.099L1185.56 567.217L1189.23 568.335L1192.49 570.266L1195.13 573.213L1196.46 578.702L1195.44 580.429L1194.11 585.714L1195.03 591.203L1193.2 593.438L1191.16 599.537L1194.11 601.163L1176.6 606.549L1177.01 611.224L1172.63 612.139L1169.27 614.68L1168.46 616.916L1166.42 617.526L1161.23 622.811L1157.97 627.079L1156.04 627.181L1154.21 626.469L1147.9 625.758L1146.88 625.25V624.742L1144.64 623.217L1140.97 622.912L1136.29 624.335L1132.63 620.27L1128.96 614.985L1129.78 594.15L1141.69 594.252L1141.28 592.016L1142.2 589.576L1141.28 586.527L1141.99 583.377L1141.38 581.344L1143.32 581.446L1143.62 583.478L1146.37 583.377L1149.93 583.987L1151.87 586.934L1156.35 587.849L1159.91 585.816L1161.13 589.17L1165.51 590.085L1167.54 592.93L1169.78 596.487H1174.16L1173.96 589.475L1172.33 590.694L1168.36 588.154L1166.83 586.934L1167.75 580.429L1168.87 572.705L1167.65 569.859L1169.38 565.692L1170.9 564.879L1178.74 563.761L1179.66 564.066L1179.35 565.489L1181.29 565.997L1182.51 567.319L1183.53 567.014L1183.02 565.896Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="ZW"
        d="M1180.27 655.232L1177.32 654.52L1175.38 655.333L1172.63 654.215H1170.39L1166.93 651.268L1162.56 650.252L1161.03 646.085L1161.13 643.747L1158.79 643.036L1152.58 635.921L1150.95 632.161L1149.83 630.941L1147.9 625.758L1154.21 626.469L1156.04 627.181L1157.97 627.079L1161.23 622.811L1166.42 617.526L1168.46 616.916L1169.27 614.68L1172.63 612.139L1177.01 611.224L1177.22 613.664L1182 613.562L1184.65 614.883L1185.77 616.509L1188.51 617.017L1191.37 619.05L1190.96 627.384L1189.63 631.856L1189.23 636.734L1190.04 638.665L1189.13 642.528L1188.31 643.137L1186.58 647.812L1180.27 655.232Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="XK"
        d="M1117.56 234.571L1116.34 234.875L1113.39 235.892L1113.28 237.213L1112.57 237.111L1111.96 234.774L1110.64 234.062L1109.42 232.335L1110.23 230.912L1111.45 230.505L1111.96 228.371L1112.88 227.964L1113.69 228.879L1114.71 229.286L1115.52 230.302L1116.44 230.607L1117.56 231.826L1118.27 231.725L1117.87 233.351L1117.26 234.062L1117.56 234.571Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="ZA"
        d="M1180.27 655.232L1182.51 664.379L1183.63 669.054L1182.2 676.27L1182.61 678.607L1179.86 677.489L1178.13 677.896L1177.52 679.827L1175.79 682.266L1175.69 684.502L1178.84 688.059L1182.1 687.348L1183.53 684.502H1187.7L1185.97 689.279L1184.95 694.665L1183.22 697.613L1179.15 700.967L1178.03 701.881L1175.38 705.235L1173.55 708.589L1169.99 713.264L1163.17 719.972L1158.99 723.834L1154.62 726.883L1148.61 729.323L1145.86 729.729L1144.94 731.558L1141.69 730.542L1138.94 731.762L1133.14 730.542L1129.78 731.355L1127.54 730.949L1121.63 733.591L1116.95 734.607L1113.39 737.047L1110.94 737.25L1108.81 734.912L1106.97 734.811L1104.73 731.863L1104.43 732.778L1103.82 731.05L1104.12 727.188L1102.6 722.818L1104.43 721.598L1104.53 716.618L1101.17 710.52L1098.73 705.032V704.93L1095.06 696.495L1097.91 693.243L1099.95 695.072L1100.76 697.816L1103.31 698.324L1106.77 699.544L1109.72 699.036L1114.81 695.682L1115.93 671.595L1117.36 672.611L1120.41 678.811L1119.8 682.774L1120.92 685.112L1124.99 684.401L1127.84 681.453L1130.59 679.522L1132.12 676.371L1134.97 674.949L1137.31 675.66L1139.85 677.489L1144.44 677.794L1148.1 676.371L1148.71 674.339L1149.93 671.188L1152.99 670.68L1154.82 668.241L1156.86 663.871L1162.15 658.992L1170.39 654.215H1172.63L1175.38 655.333L1177.32 654.52L1180.27 655.232ZM1159.6 709.301L1160.72 707.268L1163.88 706.252L1165 704.117L1166.93 700.967L1165.2 698.934L1162.96 696.901L1160.21 698.324L1157.06 700.865L1153.8 704.93L1157.57 710.012L1159.6 709.301Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_52"
        d="M666.892 851.588L673 865.41H678.09L681.144 865.614L680.635 868.053L677.377 869.984L674.934 869.781L671.778 869.272L667.502 867.443L662.005 866.528L654.37 863.073L647.855 859.821L637.879 852.808L642.561 854.129L651.316 858.296L658.748 860.532L659.969 857.686L659.664 853.418L663.125 850.775L666.892 851.588Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_53"
        d="M625.459 658.382L626.375 660.009L625.154 666.818L619.453 669.969L621.082 680.843L620.267 682.978L622.303 685.519L618.944 689.584L616.297 695.682L615.381 701.678L617.112 707.98L614.974 714.687L619.962 725.969L621.591 727.188L623.016 733.185L621.387 739.486L622.812 744.974L619.758 749.243L621.387 755.138L624.747 761.541L622.202 763.878L622.405 769.671L623.22 776.277L626.579 784.205L624.848 785.526L628.615 792.945L631.771 795.385L630.956 798.129L633.807 799.348L635.232 801.788L633.4 803.007L635.232 806.768L636.352 815.203L635.639 820.691L637.472 823.944L637.37 827.907L634.621 830.753L637.777 837.359L640.424 839.697L643.58 839.29L645.514 843.965L649.077 847.624L661.395 848.437L666.383 849.454H662.005L660.275 850.978L656.814 853.214L658.544 859.007L656.61 859.109L650.197 857.178L642.562 852.808L634.825 849.25L631.567 845.287L631.262 841.628L626.986 837.359L621.896 826.586L621.693 820.488L625.154 815.61L616.704 813.679L619.453 808.089L617.417 797.417L624.034 799.653L622.202 786.339L618.13 784.611L619.148 792.64L615.585 791.726L614.058 782.579L612.022 770.586L613.141 766.114L609.782 759.813L607.339 752.495L609.578 752.19L610.189 741.722L611.411 731.254L611.513 721.599L608.153 711.74L608.764 706.353L606.626 698.324L608.459 690.397L607.542 677.794V664.176L607.644 649.642L606.117 638.97L603.979 629.722L606.83 628.096L607.95 624.742L611.207 629.214L612.429 633.889L615.686 636.633L614.567 642.934L618.333 650.252L621.489 659.297L625.459 658.382Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="NL"
        d="M1034.8 179.993L1031.95 178.468L1028.79 175.724L1024.21 177.045L1020.54 176.537L1023.09 174.81L1027.16 165.663L1033.78 163.02L1037.85 163.223L1038.77 165.358L1037.85 171.049L1036.63 173.387H1033.68L1034.8 179.993Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="PT"
        d="M963.944 268.008L961.705 269.634L958.854 268.72L956.106 269.431L957.022 264.349L956.717 260.386L954.273 259.776L953.154 257.337L953.663 253.068L955.902 250.73L956.411 248.088L957.633 244.226V241.482L956.717 239.144L956.513 236.908L958.447 235.282L960.687 234.367L961.908 237.518H964.962L965.879 236.705L969.034 236.908L970.358 240.161L967.915 241.888L967.609 246.97L966.795 247.885L966.489 251.035L964.148 251.544L966.184 255.406L964.555 259.674L966.388 261.605L965.573 263.333L963.537 265.772L963.944 268.008Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_54"
        d="M1114.3 157.938L1105.34 158.04L1099.34 157.329L1100.05 154.686L1106.46 152.654L1111.66 153.772L1113.9 154.686L1113.69 156.414L1114.3 157.938Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_55"
        d="M1691.64 234.451L1690.21 233.333L1688.28 229.979L1690.82 229.877L1686.85 222.255L1682.07 216.766L1685.02 214.53L1692.04 215.648L1691.43 209.347L1688.58 202.436L1688.89 200.098L1687.56 194.305L1680.54 196.236L1677.89 198.676H1670.16L1664.05 192.781L1654.89 188.207L1644.71 186.175L1638.4 180.077L1633.81 176.214L1629.95 173.47L1622.11 167.169L1616 164.933L1607.24 163.002L1600.93 163.205L1595.74 164.323L1594.01 167.474L1597.78 168.897L1600.32 172.352L1599 174.385L1599.2 180.991L1601.14 183.837L1596.66 187.801L1589.12 185.361L1583.42 185.971L1579.45 183.837L1575.99 183.126L1571.51 187.597L1565.51 188.614L1561.84 190.24L1554.92 189.224H1550.24L1545.25 185.971L1538.53 183.024L1533.03 182.109L1527.23 182.922L1523.16 184.142L1514.5 181.499L1510.84 176.824L1504.02 175.198L1499.13 174.385L1492.01 171.844L1490.68 178.349L1494.76 182.008L1492.31 186.479L1484.17 184.853L1479.08 184.65L1474.19 181.703L1468.9 181.601L1463.5 179.67L1457.5 182.617L1450.68 188.004L1445.89 189.122L1444.16 189.63L1439.68 185.768L1433.57 186.683L1430.21 183.939L1426.14 182.719L1421.97 179.06L1418.61 177.942L1412.3 179.568L1403.75 176.011L1402.63 179.263L1384 163.409L1375.45 158.632L1376.26 156.599L1366.89 162.494L1362.42 162.799L1361.3 159.445L1354.07 157.311L1349.69 158.835L1345.21 152.432L1335.95 151.111L1332.79 153.652L1321.7 155.989L1319.96 157.514L1302.66 159.648L1301.23 161.783L1306.43 166.051L1302.35 167.677L1303.88 169.303L1300.32 172.352L1309.89 176.723L1309.68 179.67L1302.56 179.365L1301.74 181.296L1294.31 178.044L1286.47 178.146L1281.99 180.788L1275.27 178.247L1263.06 173.877L1255.32 174.08L1247.08 180.89L1247.69 185.463L1241.58 181.804L1239.34 188.817L1241.17 190.037L1239.44 194.915L1244.84 199.184L1248.5 198.98L1252.88 203.249L1253.08 206.501L1255.93 207.619L1254.51 211.38L1249.82 212.396L1246.16 219.002L1252.27 225.202L1252.68 229.47L1260.11 237.093L1257.56 239.735L1256.95 241.362L1254.51 240.853L1250.13 236.991L1248.6 236.788L1244.94 235.264L1242.8 232.621L1237.61 231.3L1234.66 232.316L1233.43 231.097L1225.7 227.946L1217.86 226.93L1213.18 225.812L1212.77 226.625L1205.03 221.137L1198.72 218.697L1193.53 214.937L1197.19 213.921L1200.45 208.636L1197.09 206.095L1204.12 203.452L1203.71 202.029L1199.33 203.046L1198.92 200.302L1201.16 198.472L1206.05 198.066L1206.36 195.931L1204.52 192.374L1205.85 189.122L1205.44 187.191L1197.6 185.158L1194.65 185.26L1190.98 182.312L1187.32 183.329L1180.5 181.093L1180.4 179.873L1178.06 177.129L1174.09 176.824L1173.27 174.893L1174.19 173.572L1170.32 170.015L1165.33 170.625L1163.8 170.32L1162.79 171.743L1160.95 171.539L1158.92 167.474L1157.39 165.441L1158.2 164.832L1162.17 165.035L1163.8 163.714L1162.07 162.087L1158.61 160.969V159.851L1156.47 158.734L1152.61 154.668L1153.32 153.042L1152.2 150.095L1147.31 148.672L1144.87 149.383L1143.95 147.859L1138.56 146.334L1136.42 142.675L1135.4 139.728L1132.86 138.407L1134.49 136.476L1132.04 130.784L1134.69 127.329L1133.77 126.312L1138.35 122.958L1132.86 120.113L1141 112.592L1144.46 109.136L1145.38 106.189L1137.84 102.225L1138.76 98.3631L1133.77 94.0945L1135.5 89.2161L1128.89 82.8132L1131.84 78.5446L1124.41 74.7841L1124 70.9221L1127.26 70.4139L1133.77 68.2796L1137.54 66.3485L1145.38 69.6008L1157.29 70.9221L1175.31 77.2233L1179.48 79.8658L1181.01 83.6263L1177.24 86.5736L1170.62 88.0981L1150.06 83.8295L1147.11 84.541L1155.35 88.7079L1156.37 91.3504L1158.31 97.2452L1164.52 98.9729L1168.38 100.497L1168.18 97.6517L1164.72 95.2125L1166.86 92.9765L1178.67 96.6354L1181.92 95.2125L1177.55 90.9439L1185.79 85.4557L1189.97 85.7606L1194.65 87.6916L1195.77 83.8295L1190.98 80.4756L1191.8 77.1217L1187.42 73.6662L1199.94 75.4956L1203.61 78.5446L1198.42 79.256L1199.64 82.4067L1203.81 84.3377L1209.92 83.1181L1209.51 79.5609L1217.35 76.8168L1229.97 72.1417L1233.23 72.3449L1230.69 75.6988L1236.18 76.3086L1238.32 74.3776L1246.16 74.276L1251.25 71.9384L1257.77 75.2923L1260.62 71.6335L1254.51 68.4828L1255.73 66.6534L1268.96 68.2796L1275.68 70.0073L1294.62 76.3086L1295.74 73.4629L1289.73 70.5155L1288.92 69.3975L1283.52 68.7877L1283.32 66.2469L1278.53 61.9783L1277.41 60.2505L1281.79 55.4737L1281.18 50.5953L1283.42 49.579L1295.02 51.0019L1297.98 53.9492L1297.06 58.2179L1300.83 59.9456L1304.69 63.7061L1308.56 71.227L1315.38 74.5809L1315.89 78.3413L1312.33 86.2687L1317.73 87.0818L1318.23 85.0491L1322.1 83.6263L1321.59 80.8821L1323.53 78.138L1319.05 74.9874L1318.64 71.3286L1313.76 70.9221L1310.8 67.873L1310.4 62.3848L1302.05 58.0146L1306.83 54.4574L1303.07 50.697L1305 50.5953L1309.28 53.4411L1311.41 58.6244L1316.5 59.6407L1311.82 55.7786L1317.01 53.6443L1325.26 53.3394L1335.03 56.3884L1328.01 52.0182L1323.02 46.4284L1329.03 45.412L1338.7 45.6153L1346.64 44.9039L1340.94 42.2614L1342.26 38.9075L1346.53 38.7042L1351.52 36.265L1360.99 35.5536L1360.79 34.1307L1370.25 33.7242L1374.63 34.8421L1380.13 32.1997L1387.25 32.3013L1385.73 30.0653L1386.64 28.0327L1392.96 26L1401.4 27.6261L1397.84 28.8457L1407.41 29.5572L1411.58 31.9964L1413.52 30.7768L1424.62 30.8784L1436.42 33.3176L1442.02 35.147L1444.57 37.7895L1442.12 39.314L1435.41 42.1597L1434.29 43.6842L1439.99 44.3957L1447.32 45.7169L1449.76 44.7006L1455.66 48.0545L1455.87 46.7333L1461.16 45.9202L1475.01 46.7333L1478.87 49.1725L1496.59 49.9855L1491.7 46.0218L1501.37 46.9365L1507.58 46.8349L1517.66 49.579L1523.77 52.9329L1524.18 55.1688L1534.46 59.4375L1543.62 61.5718L1540.57 55.9819L1550.13 58.3195L1555.22 56.8966L1565.2 58.5228L1566.22 57.0999L1573.96 57.8113L1564.39 52.8313L1566.52 50.5953L1607.65 54.0509L1615.69 57.2015L1632.29 61.2669L1647.35 60.2505L1656.82 61.1652L1663.54 63.4012L1668.73 67.3649L1676.16 68.8894L1680.13 67.7714L1687.26 67.6698L1696.73 68.6861L1703.75 68.0763L1718.31 72.9547L1720.85 71.227L1712.2 67.7714L1710.37 65.3322L1725.94 66.8567L1734.09 66.5518L1750.17 69.0927L1759.84 71.5319L1793.64 93.9929L1791.6 96.5337L1785.29 96.1272L1793.64 99.1762L1802.9 103.953L1807.18 105.477L1811.05 107.917L1812.07 109.441L1801.89 108.222L1795.17 112.592L1792.11 113.303L1790.48 117.47L1788.45 121.129L1790.18 123.873L1778.47 119.706L1772.26 124.381L1767.48 122.145L1766.05 124.788L1758.93 123.873L1762.08 127.837L1763.2 133.732L1766.15 136.171L1773.08 137.492L1782.34 146.334L1778.17 146.639L1781.63 151.721L1786.41 154.363L1781.32 157.514L1786.82 164.628L1781.02 166.153L1785.6 172.454L1783.87 178.349L1778.06 173.979L1767.38 164.933L1750.88 151.111L1744.27 142.675L1744.37 139.017L1741.52 136.171L1747.32 134.85L1747.12 127.227L1747.83 121.129L1750.38 116.352L1743.66 108.018L1738.87 108.526L1742.13 113.405L1738.46 119.909L1725.94 112.592L1716.68 114.625V124.585L1724.52 128.243L1715.87 129.87L1709.35 130.479L1704.97 126.109L1696.83 125.194L1694.28 128.142L1678.91 127.125L1665.47 128.853L1661.91 140.744L1656.82 155.176L1665.17 155.989L1670.97 159.851L1676.88 161.173L1677.28 158.124L1682.98 158.53L1696.01 165.34L1700.8 170.625L1702.22 176.926L1707.82 184.447L1713.22 194.509L1712.2 203.757L1713.52 208.127L1711.49 215.648L1709.35 223.068L1708.43 226.828L1703.75 230.588L1700.6 230.69L1695.3 227.539L1691.13 232.316L1691.64 234.451Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_56"
        d="M1185.77 13.3139L1181.39 13.8221L1178.44 14.2286V14.94L1174.77 15.6515L1170.19 14.6351L1171.31 13.2122L1163.37 13.1106L1169.78 12.2975H1175.08L1176.6 13.4155L1177.93 12.3992L1180.78 11.6877L1186.68 12.6024L1185.77 13.3139Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="ES"
        d="M994.179 227.05L996.215 229.489L1005.89 232.436L1007.82 231.013L1013.72 233.961L1019.73 233.148L1020.14 236.908L1015.15 241.177L1008.43 242.6L1007.92 244.734L1004.66 248.291L1002.63 253.576L1004.66 257.336L1001.61 260.182L1000.39 264.451L996.317 265.772L992.55 270.752L985.628 270.854L980.538 270.752L977.076 272.988L974.939 275.427L972.292 274.919L970.358 272.683L968.932 269.024L963.944 268.008L963.537 265.772L965.573 263.333L966.387 261.605L964.555 259.674L966.184 255.405L964.148 251.543L966.489 251.035L966.795 247.884L967.609 246.97L967.914 241.888L970.358 240.16L969.034 236.908L965.878 236.705L964.962 237.518H961.908L960.687 234.367L958.447 235.282L956.513 236.908L957.022 232.335L954.986 229.59L962.519 224.915L968.831 226.033H975.855L981.352 227.151L985.729 226.745L994.179 227.05Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_57"
        d="M1054.34 235.18L1052.82 240.16L1050.37 238.839L1049.05 234.57L1049.97 232.131L1053.22 229.692L1054.34 235.18Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_58"
        d="M120.938 385.496L119.819 386.614L118.597 385.699L119.208 383.87L118.801 381.431L119.31 380.719L120.531 379.703L120.429 378.382L120.837 377.772L121.244 377.874L123.178 378.992L124.094 379.601L124.807 380.414L125.723 382.752L125.519 383.057L122.974 384.48L120.938 385.496Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_59"
        d="M120.226 375.333L118.19 375.739L117.579 374.418L117.07 373.91V373.503L117.783 372.893L119.615 373.503L120.837 374.519L120.226 375.333Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_60"
        d="M117.172 371.878L116.867 372.589L113.812 372.386L114.423 371.573L117.172 371.878Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_61"
        d="M112.387 370.861L111.98 371.267L111.573 371.166L109.638 370.962L109.333 369.438L109.129 369.235L110.86 368.32L111.267 368.726L112.387 370.861Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_62"
        d="M103.836 366.593L103.022 367.202L101.393 366.085L101.8 365.576L102.818 364.967L104.141 365.068L103.836 366.593Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_63"
        d="M279.95 140.864L272.824 143.202L272.01 141.576L274.351 138.73L280.866 136.596L284.429 135.681L287.076 136.087V138.018L279.95 140.864Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_64"
        d="M240.248 123.993L236.278 124.908L234.547 123.79L233.733 122.164L239.535 121.147L242.589 121.757L240.248 123.993Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_65"
        d="M241.47 101.227L242.691 102.244L246.254 101.735L247.883 103.26L251.242 103.971L250.021 104.683L245.032 105.902L243.302 104.581L242.996 103.565L238.619 103.87L238.314 103.362L241.47 101.227Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_66"
        d="M417.38 67.6876L392.337 88.4208L356.097 121.655L360.372 121.858L363.223 123.484L363.732 126.127L364.037 129.989L371.774 126.635L378.391 124.704L377.78 127.855L378.594 130.294L380.223 133.038L379.103 137.307L377.678 144.319L382.361 148.181L379.103 152.043L373.912 154.991L373.301 152.755L370.756 150.722L374.115 145.437L372.486 140.457L375.235 134.766L371.061 134.359L363.833 134.258L359.965 132.428L356.606 126.229L353.246 125.111L347.444 122.976L340.521 123.484L334.413 120.74L331.665 118.199L325.251 119.419L321.688 123.586L318.736 123.993L312.017 125.212L305.706 127.245L299.19 128.566L302.448 125.009L310.999 119.114L317.922 117.285L318.329 115.862L308.76 119.114L301.226 123.078L289.825 127.346L290.028 130.294L280.866 134.562L273.028 137.103L266.309 139.034L262.237 141.677L251.446 144.827L246.865 147.673L238.518 150.316L235.769 149.909L229.457 151.535L222.331 153.67L216.122 155.702L205.942 157.532L206.349 156.414L214.696 153.568L221.415 151.637L230.17 148.283L236.787 147.673L241.877 145.132L252.464 141.474L254.806 140.254L260.608 138.12L266.513 133.546L272.824 129.989L265.393 131.818L265.087 130.7L260.099 132.936L260.506 129.887L256.842 132.022L258.47 129.074L251.039 131.412H248.189L251.955 127.855L255.315 125.619L254.907 123.484L247.578 124.704L246.967 121.858L245.644 120.435L249.716 117.081L249.308 114.541L255.315 111.187L263.153 107.833L268.549 104.885L272.722 104.479L274.555 105.394L281.783 102.548L284.328 103.056L290.028 101.227L292.573 98.5842L291.454 97.5679L297.562 95.3319L294.711 95.4335L288.4 96.6531L285.447 97.9744L283.615 96.6531L276.591 97.3646L271.908 95.9417L273.13 93.6041L272.112 90.3519L281.477 87.9127L294.915 85.1686H298.478L294.1 88.0143L303.466 87.811L304.688 84.2539L302.346 82.1196L303.161 79.2738L302.448 76.9362L299.089 75.2085L305.706 72.2611L313.341 72.0578L322.299 69.6186L327.185 66.9761L335.228 64.3337L340.114 63.7239L351.516 61.2847L354.671 61.6912L365.259 58.8455L369.738 59.9634L369.229 62.4026L372.588 61.3863L379.002 61.6912L377.067 62.9108L382.056 63.8255L387.044 63.3173L393.355 64.9435L400.685 65.5533L402.925 66.1631L409.643 65.35L413.817 66.9761L417.38 67.6876Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="GF"
        d="M689.491 494.955L691.018 492.11L691.527 489.162L692.545 486.418L690.408 482.556L690.102 478.084L693.258 472.494L695.192 473.206L699.366 474.73L705.372 480.219L706.187 482.861L702.725 488.857L700.893 493.634L698.653 496.175L695.905 496.582L695.09 494.752L693.767 494.549L692.036 496.277L689.491 494.955Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="AW"
        d="M603.572 428.894L603.063 428.69L602.554 428.182L602.656 427.573L602.86 427.877L603.267 428.284L603.572 428.792V428.894Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="AI"
        d="M645.616 391.188H645.412L645.717 390.781H646.023L645.819 391.086L645.616 391.188Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_67"
        d="M28.1985 602.992L27.8931 603.399L27.6895 603.704L27.4859 603.805L27.0787 603.5L27.2823 603.297H27.5877L27.6895 603.094L28.1985 602.992Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_68"
        d="M34.9173 602.992L34.4083 603.094L34.3065 602.891L34.7137 602.789L34.9173 602.992Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_69"
        d="M652.233 398.302L652.843 398.607L652.64 398.912H652.436L651.723 399.014L651.52 398.912V398.404L651.825 398.302L651.927 397.998H652.131L652.233 398.302Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_70"
        d="M652.233 394.542H652.436L652.64 394.745L652.741 395.151L652.64 395.456L652.436 395.558L652.334 395.355L652.029 395.151V394.643L652.233 394.542Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_71"
        d="M590.847 371.979L590.44 372.487L590.236 372.995L589.626 373.3H589.117L589.015 373.198L588.608 373.402L588.099 373.503L587.488 373.3L587.081 373.402L586.979 372.894L587.284 372.69L587.488 372.385L587.895 372.182L588.2 371.776H588.608L588.913 371.572L589.117 371.877L589.626 372.08L590.135 371.877L590.847 370.861H591.153V371.064L590.847 371.979Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_72"
        d="M591.051 370.251L590.847 369.641L591.458 369.336L591.763 369.641V369.844L591.458 369.946L591.051 370.251Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_73"
        d="M591.458 363.645L591.661 363.544L592.17 363.848H592.578L592.985 363.95L593.29 364.153V364.458L593.087 364.56L592.578 364.153H592.17L592.069 364.052L591.56 364.255L591.051 364.052V363.95L591.254 363.442L591.458 363.645Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_74"
        d="M587.488 361.816L587.284 362.222V362.934L587.183 363.34L586.775 363.645L586.572 364.052L586.165 364.357L585.452 364.661L585.35 364.865L585.146 364.661L585.248 364.458L585.655 364.357L585.859 364.153V363.95L586.266 363.848L586.47 363.442L586.877 363.34L587.183 362.934L586.979 362.629H586.572L586.368 362.425L586.775 361.917L586.877 361.816H587.488Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_75"
        d="M585.554 361.511L585.656 361.612H586.063L586.47 361.815L586.063 362.222L585.961 362.019H585.757L585.35 361.917L584.943 361.714L584.638 361.104L584.943 361.002L585.35 361.104L585.554 361.511Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_76"
        d="M576.188 355.515L576.799 356.226L577.104 356.429L577.41 356.938L577.104 356.836L577.002 356.633L576.697 356.531L576.29 356.124L576.086 356.023L575.883 355.616L576.188 355.515Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_77"
        d="M579.955 355.515L580.26 356.124L580.464 356.633V357.039L580.667 357.242L580.871 357.954V358.869L581.074 359.173L581.583 359.377L581.991 359.987V360.8L581.583 360.088V359.885L581.278 359.478L580.667 359.275L580.871 359.072L580.565 358.767V358.462L580.769 358.157L580.667 357.649L580.362 357.242L580.464 357.141L580.158 356.734L580.056 356.124L579.853 356.226L579.955 355.515Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_78"
        d="M582.907 355.514L582.601 355.718L582.296 355.616L582.194 355.413L582.805 355.209L582.907 355.514Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_79"
        d="M574.559 353.584L574.457 353.482L574.152 352.771H574.356L574.559 353.584Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_80"
        d="M585.248 353.075L584.841 353.685H584.434L584.637 353.38L584.739 352.77L585.146 352.465L585.248 352.872V353.075Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_81"
        d="M566.415 351.856L566.11 351.957L565.906 352.262L565.601 352.161L566.212 351.754L566.415 351.856Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_82"
        d="M566.619 352.567L567.026 352.77L567.229 352.567L567.331 352.059L567.535 351.957L567.738 352.567V353.075L567.637 353.38L567.738 353.99V354.295L567.331 355.108L567.128 355.21L566.72 355.006L566.924 354.701L567.331 354.498L567.229 354.397L566.619 354.803L566.415 354.6L566.822 354.295H566.415L566.211 354.397L566.008 354.193V353.482L566.11 353.279L565.702 352.77V352.567L566.11 352.364L566.211 352.059L566.517 351.957L566.619 351.754L567.229 351.449L567.331 351.856L566.822 352.262L566.619 352.567Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_83"
        d="M580.362 351.957L580.464 352.465L580.26 352.364L579.751 352.465L579.344 352.567L579.242 352.364L579.547 352.16L579.955 351.855V351.652L579.547 351.449L579.344 350.839L579.242 350.229L578.835 349.823V349.619L578.326 349.111L578.631 348.806L579.038 349.213V349.721L579.242 350.026L579.344 350.534L579.649 351.042L580.056 351.347L580.158 351.652L580.362 351.957Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_84"
        d="M569.876 346.367L570.182 346.571L569.571 346.876L569.266 346.774L569.062 346.977L568.553 346.876L568.757 346.571L569.164 346.367H569.876Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_85"
        d="M565.601 345.859L566.008 345.656L566.313 345.961L566.211 346.164L566.313 346.367L566.11 346.774L566.415 347.079L566.619 347.993L566.822 348.298L567.229 348.807L567.026 349.518L567.128 350.128L566.924 350.433L566.619 350.534L566.211 350.941L565.906 351.144H565.601L565.295 351.347H564.99V350.941L564.684 350.738L564.786 350.128L564.481 350.433L564.277 350.331L563.666 349.924L563.361 349.62L563.157 349.315L563.87 349.01L564.379 349.721L564.481 349.111L564.175 349.01L564.074 348.705L564.175 348.4L564.786 347.79L564.99 347.384L564.888 347.282L565.193 346.875V346.367L564.99 345.656L565.092 345.554H565.397L565.601 345.859Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_86"
        d="M573.846 343.217L573.948 343.42L574.254 343.826L575.068 344.538L575.577 344.639L575.679 344.741L575.882 345.148L576.188 345.554L576.697 345.961V346.164L576.493 346.977L576.391 347.18V347.485L576.29 347.993L576.086 348.298L575.984 349.01L575.882 349.111L575.679 348.502L575.272 348.197L575.373 347.993L575.882 348.095L576.086 347.892L575.984 347.688L576.086 347.282L576.391 346.875L576.493 346.367V346.062L575.984 345.656L575.577 344.944L575.272 344.741L574.661 344.436L574.355 344.131L573.745 343.928L573.337 344.131L573.745 343.217H573.846Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_87"
        d="M564.888 335.594L565.397 335.797H565.499L566.212 335.899L566.415 335.696L566.619 335.797H567.128L567.535 335.594H567.942L568.248 335.391L568.349 335.899L568.248 336.102H567.942H567.535L566.415 336.306H566.11L564.583 336.712L563.87 337.119H563.463L563.259 337.017L562.954 336.712L562.445 336.102L563.056 336.407L563.158 336.61H563.667L564.176 336.407L564.583 335.797L564.277 335.696L564.481 335.391L564.583 335.086L564.888 335.594Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_88"
        d="M569.266 334.273L570.08 334.476L570.284 334.374L570.691 334.679L571.607 335.696L571.811 336.305L572.218 336.407L572.93 336.915V337.118L572.727 337.627L572.93 338.338H572.523L572.014 338.745L571.912 338.948L571.607 339.964L571.505 340.879L571.302 341.082L570.996 340.879L570.894 340.472L570.487 340.371L570.793 339.863H570.996L571.505 339.456L571.403 339.05L571.607 338.643V338.338L571.811 338.033V337.423L572.014 337.322L572.218 337.017L572.32 336.712L572.014 336.61L571.505 336.509L571.403 336.204V336.001L570.996 335.797V335.492L570.691 334.781L570.487 334.679L570.182 334.781L569.673 334.679H569.367L568.757 334.273H569.266Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BL"
        d="M646.634 393.322L646.532 393.017L646.837 393.119L646.634 393.322Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BM"
        d="M648.771 298.802H648.466L648.364 298.904L648.466 299.107L648.059 299.311L647.957 299.209L648.161 299.107H648.262L648.364 298.802L648.67 298.701L648.771 298.802Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BB"
        d="M663.227 424.829L662.616 424.625L662.515 424.117V423.304L662.718 422.898L662.922 423.101L663.125 423.711L663.634 424.016L663.736 424.422L663.227 424.829Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_89"
        d="M863.06 413.14L862.857 413.445L862.653 413.242V412.937L862.959 412.835L863.06 413.14Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_90"
        d="M864.994 413.242L864.791 413.344L864.384 413.242L864.078 412.937L863.976 412.633L864.18 412.226L864.689 411.921H865.096L865.3 412.633L865.198 413.039L864.994 413.242Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_91"
        d="M868.558 410.092L868.761 410.193V410.396L868.965 410.6L869.372 411.108H869.576L869.779 411.413L869.983 411.921L870.186 412.124L869.881 412.632L869.576 412.734L869.067 412.632L868.761 412.531L868.456 412.226V412.023L868.252 411.921L868.15 411.514L868.252 411.311V411.006L868.456 410.6L868.252 410.092H868.558Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_92"
        d="M871.713 410.092L872.019 410.193L872.121 410.803L872.019 411.21L871.612 411.413L871.204 411.006L871.408 410.6L871.306 410.396L871.713 410.092Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_93"
        d="M873.749 404.299L874.055 404.095L874.564 404.299L874.665 404.502V405.213L874.258 405.518L873.953 405.722H873.647L873.138 405.518V405.01L873.342 404.807V404.197L873.444 404.095L873.749 404.299Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_94"
        d="M865.605 401.453L866.013 401.351L866.318 401.554H866.725L867.031 401.757L867.132 401.961H866.623L865.911 401.656L865.707 401.757L865.402 402.367L865.096 401.757L864.995 401.656L864.893 401.249L865.198 401.148L865.605 401.453Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_95"
        d="M873.546 400.945L873.648 401.046L873.546 401.656L873.342 401.758V401.25L873.139 400.945V400.64L873.037 400.335L873.444 400.03L873.648 400.233L873.546 400.843V400.945Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_96"
        d="M862.042 399.623L862.246 399.928L862.348 400.233L861.635 400.538L861.33 400.335L861.126 400.131L861.533 399.725L862.042 399.623Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_97"
        d="M861.228 397.793L861.533 397.895V398.098L861.839 398.403L861.635 398.81L861.024 399.115L860.617 399.521L859.905 399.623V399.521V399.013L859.701 398.81V398.607L859.905 398.403H860.108L860.312 398.2L861.024 397.793H861.228Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="CW"
        d="M609.782 431.435H609.477L609.069 431.13L608.764 431.028L608.459 430.723L608.357 430.52L608.051 430.419L607.848 430.012L607.542 429.707L607.644 429.199L608.153 429.504L608.255 430.012L608.662 430.419L609.375 430.622L609.578 430.927L609.884 431.333L609.782 431.435Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_98"
        d="M542.289 383.972L542.594 384.074L542.798 383.667L543.205 383.769H543.714L543.816 383.972L543.612 384.175L543.408 384.074L543.001 384.175L542.798 384.277H542.085L542.289 383.972Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_99"
        d="M550.534 381.431L549.822 381.736L550.025 381.431H550.534Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_100"
        d="M551.145 381.533L551.043 381.431L551.858 381.126L551.654 381.431L551.145 381.533Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_101"
        d="M1189.23 281.22L1189.33 281.423L1189.63 281.83L1189.23 281.728H1188.92L1188.52 281.932L1188.21 281.627V281.322L1188.52 281.22L1188.72 281.322L1189.23 281.22Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_102"
        d="M1187.5 281.728V281.83L1187.29 282.033L1187.19 282.643L1187.09 282.846H1186.78L1186.58 283.049L1186.07 283.253L1185.87 283.354L1185.26 283.659L1184.85 283.557L1184.34 283.659L1184.04 284.066L1183.83 283.761L1183.53 283.862H1183.32L1183.02 283.557L1182.61 283.862H1182.1L1181.59 283.659L1181.08 283.557L1180.68 283.253L1180.37 282.643L1180.07 282.338L1179.86 281.626L1179.66 281.321L1179.76 281.017L1180.27 281.321L1180.68 281.22L1180.88 280.915L1180.98 280.61L1181.29 280.508L1181.49 280.61L1181.69 280.407H1181.9L1182 280.813L1182.51 281.017L1182.61 281.22H1183.22L1183.83 280.712L1184.24 280.813L1184.54 280.61L1184.85 280.712L1185.26 280.915L1185.46 280.61H1185.77L1186.07 281.017V281.626L1186.38 281.423L1186.68 281.626L1186.78 281.525L1187.5 281.728Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="DM"
        d="M653.556 408.262L654.065 408.364L654.269 408.872V409.482L654.167 410.295L654.065 410.498L653.861 410.6L653.454 410.803L653.556 410.396L653.454 410.193L653.352 409.482L653.047 408.974V408.669L653.149 408.364V408.059H653.352L653.556 408.262Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_103"
        d="M709.953 849.86L710.36 849.759V850.165L709.546 849.86L709.851 849.556L710.055 849.454L709.953 849.86Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_104"
        d="M709.241 848.438L709.444 848.641L709.851 848.742L709.953 849.149L709.648 849.25L709.546 848.844L709.342 848.641L709.241 848.438Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_105"
        d="M715.552 847.624L715.756 847.726L715.654 848.132L715.348 848.031L715.145 847.726L715.45 847.522L715.552 847.624Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_106"
        d="M703.234 846.71V846.913L703.336 847.218L702.929 847.32L702.624 847.218L702.42 847.015L702.115 846.913L702.013 846.507H702.216L702.318 846.303L702.624 846.202L702.827 846.303L702.522 846.608L702.827 846.71L703.133 846.405L703.234 846.71Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="Vector_107">
        <path
          d="M706.187 845.388L705.779 845.185L705.27 844.88L704.456 844.575L704.558 844.168L703.845 844.067L703.54 843.965L703.235 843.559L703.438 843.457L704.252 843.762L705.067 844.168L705.576 844.27L705.983 844.372L706.288 844.067L706.39 843.762L706.594 843.864L707.001 843.66L707.103 843.864H707.612V844.168H707.917L708.833 843.965L708.935 844.168H709.241L709.648 844.067L709.342 843.864L709.241 843.559H709.648L710.259 843.762L710.36 844.168L709.953 844.677L710.055 844.982L709.851 845.185H709.444L709.139 845.998L708.833 846.303L708.528 846.912L708.426 847.217L707.917 847.522L707.815 847.319H707.408V847.624L706.594 847.522L706.492 847.624L706.797 848.03L706.696 848.132L706.492 848.539H706.085L705.779 848.945L705.474 849.047H705.27L705.067 848.742L704.66 848.437V848.234H704.151L704.761 848.64H704.354L703.845 848.335L703.642 848.234L703.235 848.03L702.929 847.827V847.624L703.642 847.827L704.252 847.624L703.744 847.421L703.642 847.319H704.558L704.965 847.421L705.27 847.624V847.421L705.678 847.319L705.779 847.014L705.372 846.811L705.169 846.303L705.27 846.099H705.881L706.085 846.201L706.492 846.099L706.39 845.795H705.576V845.896L705.169 846.099H704.558L704.049 845.795V845.49L704.761 845.693L705.372 845.49H705.678L706.187 845.388L706.594 845.591V845.49L706.187 845.388Z"
          fill="#1D1D28"
        />
        <path
          d="M706.187 845.388L705.779 845.185L705.27 844.88L704.456 844.575L704.558 844.168L703.845 844.067L703.54 843.965L703.235 843.559L703.438 843.457L704.252 843.762L705.067 844.168L705.576 844.27L705.983 844.372L706.288 844.067L706.39 843.762L706.594 843.864L707.001 843.66L707.103 843.864H707.612V844.168H707.917L708.833 843.965L708.935 844.168H709.241L709.648 844.067L709.342 843.864L709.241 843.559H709.648L710.259 843.762L710.36 844.168L709.953 844.677L710.055 844.982L709.851 845.185H709.444L709.139 845.998L708.833 846.303L708.528 846.912L708.426 847.217L707.917 847.522L707.815 847.319H707.408V847.624L706.594 847.522L706.492 847.624L706.797 848.03L706.696 848.132L706.492 848.539H706.085L705.779 848.945L705.474 849.047H705.27L705.067 848.742L704.66 848.437V848.234H704.151L704.761 848.64H704.354L703.845 848.335L703.642 848.234L703.235 848.03L702.929 847.827V847.624L703.642 847.827L704.252 847.624L703.744 847.421L703.642 847.319H704.558L704.965 847.421L705.27 847.624V847.421L705.678 847.319L705.779 847.014L705.372 846.811L705.169 846.303L705.27 846.099H705.881L706.085 846.201L706.492 846.099L706.39 845.795H705.576V845.896L705.169 846.099H704.558L704.049 845.795V845.49L704.761 845.693L705.372 845.49H705.678L706.187 845.388ZM706.187 845.388L706.594 845.591V845.49L706.187 845.388Z"
          stroke="#6C7099"
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        id="Vector_108"
        d="M707.816 843.457H708.121L708.426 843.762L708.121 843.864H707.816V843.457Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_109"
        d="M706.797 843.458H706.492L706.39 843.153L706.797 843.254V843.458Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_110"
        d="M705.372 843.254L705.983 843.153L706.186 843.458L705.881 843.864L705.677 843.762L705.372 843.864L705.067 843.661L705.372 843.458L705.677 843.661L705.779 843.458L705.27 843.356L705.372 843.254Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_111"
        d="M712.702 843.356H713.313L713.414 843.254L713.923 843.153L714.331 843.356L714.738 843.661L714.84 843.966V844.067L714.331 844.169L714.127 843.864L713.923 843.762L713.822 844.067L714.025 844.169L714.127 844.474L714.432 844.271L714.636 844.372L714.738 844.779L715.043 844.88L715.145 844.779L715.654 845.084L715.756 844.677L714.941 844.474L715.043 843.966L715.348 843.762L716.875 843.661L717.588 844.271L717.792 844.372V844.779L717.181 844.677L716.672 844.474L716.061 844.677L716.366 844.88L716.774 844.982L717.69 845.084L717.995 845.185L718.097 845.389L717.893 845.897H717.384L717.283 845.998L716.57 846.1L716.061 846.303L716.366 846.507L715.45 846.913L715.043 846.811L714.534 846.913H713.822L713.211 846.71L712.6 846.303V846.608L712.905 846.811L713.516 847.015L713.822 847.32L714.025 847.218L714.432 847.32L714.84 847.625L714.636 847.726L714.84 848.234H714.636L714.331 847.929L713.923 847.828L713.414 848.234L713.211 847.929L712.905 847.726H712.6L712.091 847.523L711.887 847.625L712.091 848.031H712.396L712.6 848.234L712.396 848.336L713.109 848.946L712.905 849.047L712.498 848.844H712.193L711.887 848.539L711.582 848.438L711.277 848.336L711.175 848.946L711.684 849.047V849.352L711.582 849.556L711.175 849.454L711.073 849.251L710.564 849.047L710.462 848.844H710.259L709.851 848.336L710.157 847.929V847.726L709.75 847.218V847.015L710.259 846.811L710.157 846.608L710.666 846.507L710.564 846.202L711.175 845.795L711.786 845.592L712.193 845.998V846.405L712.498 846.303L711.989 845.693L712.091 845.389L711.48 845.185L711.073 844.88L711.175 844.677L711.582 844.88L711.684 844.372L710.971 844.169L711.073 843.864L711.277 843.966L711.582 843.762H711.887L712.091 843.458L711.786 843.153H712.193L712.702 843.356Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_112"
        d="M707.612 842.949H708.325L708.528 843.152L708.732 842.949L708.935 843.051L709.139 843.356L708.935 843.457L708.528 843.356L708.121 843.152L707.307 843.051L707.408 842.848L707.612 842.949Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_113"
        d="M700.689 841.831L700.18 841.73L700.282 841.526L700.689 841.831Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_114"
        d="M972.801 113.83L973.208 114.033H973.513L973.615 114.236V114.643L973.819 114.948L973.717 115.151L973.106 114.744L972.903 114.338L972.699 114.134L972.495 113.83H972.801Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_115"
        d="M973.106 112.204L973.92 112.407L974.124 112.61L974.022 113.017L973.92 113.118L973.513 112.61L973.004 112.509L972.801 112.102L973.106 112.204Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_116"
        d="M971.803 110.821L971.885 110.984H972.19V111.289H971.783L971.579 111.492L970.968 111.289L970.765 111.187L970.561 110.882L971.07 110.78L971.172 110.679L971.739 110.773L971.477 110.577L971.681 109.764L972.19 109.866L972.495 110.374V110.476L973.106 110.679L973.412 111.187L973.717 111.39L973.615 112L973.106 111.594L972.903 111.39L972.699 111.289L972.597 111.085L972.394 110.882H971.885L971.803 110.821Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_117"
        d="M975.549 110.171L975.346 109.967L975.651 109.764L975.549 110.171Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_118"
        d="M973.106 110.679L972.699 110.476L972.394 110.171L972.292 109.866L972.394 109.764L972.801 109.663H973.106L973.717 110.069L973.615 110.272L973.717 110.476L974.328 110.679V110.882L973.921 111.187L973.106 110.679Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_119"
        d="M975.346 110.069L975.04 110.476L974.735 110.272H974.43L974.633 109.967L974.531 109.561L974.633 109.459L974.837 109.866L975.346 110.069Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_120"
        d="M974.43 110.069H974.226L974.023 109.663L974.124 109.358L974.328 109.764L974.43 110.069Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="GD"
        d="M650.706 431.435L650.298 431.74L650.095 431.638L649.993 431.13L650.197 430.622L650.502 430.215H650.807L650.909 430.52L650.807 431.231L650.706 431.435Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_121"
        d="M647.754 398.403H647.448L647.346 398.2L647.55 397.793H647.754L647.855 397.997L647.754 398.403Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_122"
        d="M647.041 396.879L646.939 397.184H646.735L646.328 396.981L646.125 396.778L646.43 396.371L646.939 396.778L647.041 396.879Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="LC"
        d="M655.287 420.56L655.083 420.357L654.676 420.153L654.574 419.95V419.34L654.676 419.137L655.388 418.019L655.694 418.222V418.934L655.592 419.747L655.49 420.153L655.287 420.56Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="MF"
        d="M645.616 392.306L645.209 392.204L645.412 391.899L645.717 391.798L645.616 392.306Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_123"
        d="M1083.05 276.138L1082.85 276.443L1082.34 276.24L1081.83 275.935V275.427L1081.73 275.325H1082.34L1082.74 275.63L1082.95 275.833L1083.05 276.138Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_124"
        d="M1081.42 275.021L1080.91 274.919V274.716L1081.32 274.614L1081.73 274.919L1081.42 275.021Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="MS"
        d="M649.688 400.334L649.891 400.741V401.046L649.688 401.249L649.484 401.148L649.382 400.843L649.688 400.334Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_125"
        d="M618.028 392.204L617.722 392.001L617.824 391.798H618.13L618.231 391.899L618.028 392.204Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_126"
        d="M632.89 391.696H632.687L631.771 392.001H631.16L631.364 391.798L631.771 391.594L632.178 391.493L632.789 391.594L632.89 391.696Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_127"
        d="M623.22 389.256L623.83 389.358H624.441L624.747 389.46L625.357 389.358L625.663 389.46L626.07 389.358L626.274 389.46L626.783 389.358L627.19 389.46H627.495L628.31 389.663V389.46L628.92 389.663L629.022 389.561L629.837 389.663L630.04 389.866H630.244L630.855 390.171L631.058 390.069L630.956 390.781L631.16 391.086L630.244 391.391L629.938 391.797L629.633 392.407L629.328 392.61L629.022 392.712H628.615L628.004 392.814L627.699 393.017L626.986 392.915L626.783 392.712L626.274 392.915L625.968 392.61L625.256 392.814L624.339 392.712L624.034 392.814L623.423 392.915L623.22 393.017L623.016 392.814L622.609 392.712L622.303 392.915L621.693 392.814L621.998 392.102V391.696L622.202 391.289L621.998 390.679L621.794 390.578L621.693 390.171L622.1 389.968L622.303 389.866V389.358L622.711 389.155L623.22 389.256Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_128"
        d="M198.815 690.397L198.714 690.295L198.51 689.99L198.612 689.787L198.917 689.99L198.815 690.397Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_129"
        d="M209.301 651.674L209.199 651.776L208.894 651.573L209.097 651.37L209.301 651.674Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_130"
        d="M202.989 626.571L202.786 626.469L202.989 625.86L203.498 625.453H203.804V625.656L203.6 626.063L202.989 626.571Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_131"
        d="M154.431 625.555L155.143 625.758L155.449 626.165V626.47L155.245 626.571L154.736 626.47L154.329 625.86L154.227 625.656L153.616 625.86H153.413L152.802 625.758L152.598 625.352L152.293 624.843V624.539L152.395 624.335L152.904 624.234H153.413L153.922 624.437L154.125 624.843L154.227 625.453L154.431 625.555Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_132"
        d="M151.377 624.03L151.173 624.64L150.664 624.437L150.766 624.132L151.275 623.928L151.377 624.03Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_133"
        d="M143.64 619.66L143.436 619.762L143.233 619.457L143.538 619.355L143.64 619.66Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_134"
        d="M141.502 620.067L141.197 620.27H140.891L140.688 619.457L140.891 619.254L141.604 620.067H141.502Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_135"
        d="M140.484 618.237L140.687 618.339V618.847L140.28 618.644L140.178 618.339L140.484 618.237Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_136"
        d="M169.293 615.29L168.988 615.391L169.09 615.086L169.293 615.29Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_137"
        d="M207.978 578.803H207.672V578.397L207.469 578.092L207.876 578.194L207.978 578.6V578.803Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_138"
        d="M204.822 575.246H204.618V574.84L204.822 574.535L205.127 574.738L204.923 574.941L204.822 575.246Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_139"
        d="M206.043 573.62V573.925L205.636 574.027H205.025V574.332L204.618 574.23L204.414 574.027L204.312 573.722L205.025 573.315H205.331L205.534 573.519L206.043 573.62Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_140"
        d="M199.019 570.977V571.384V571.587H198.714L198.408 571.181L198.714 570.876L199.019 570.977Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_141"
        d="M201.462 567.929L201.768 568.03L201.869 568.132L201.259 568.335L201.157 568.03L201.462 567.929Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_142"
        d="M197.696 567.319L198.612 567.42L198.917 567.725V567.928L198.51 568.233H197.696L197.594 567.725L197.492 567.319H197.696Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_143"
        d="M1042.33 509.489H1042.13L1041.92 509.794H1041.72L1041.62 509.387L1041.41 508.574V508.269L1041.82 507.761L1042.13 507.66L1042.43 507.355L1042.84 507.456L1043.04 507.863L1043.14 508.168L1043.04 508.574L1042.84 508.879L1042.53 509.286L1042.33 509.489Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_144"
        d="M1047.01 499.529L1046.91 499.834L1046.71 499.935L1046.4 499.834V499.529L1046.61 499.427V499.122L1046.81 498.919L1047.11 499.021L1047.01 499.529Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="SX"
        d="M645.616 392.305V392.407L645.209 392.305V392.204L645.616 392.305Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_145"
        d="M598.279 367.507H598.991L599.297 367.914H598.991L598.686 367.812L598.177 367.914L598.075 367.609L598.279 367.507Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_146"
        d="M595.53 367.406L595.835 367.812L596.446 367.71L596.243 367.914H595.632L595.225 367.71L595.53 367.406Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_147"
        d="M597.769 366.796V367.304L597.261 367.101L597.159 366.796L597.261 366.694L597.769 366.796Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_148"
        d="M14.9644 649.947L14.4554 649.642V649.439L14.7608 649.236L14.9644 649.947Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_149"
        d="M12.1143 647.812H12.4197L12.8269 648.117L13.1323 648.219L13.3359 647.812L13.6413 648.117L13.3359 648.422L13.4377 648.626L13.3359 648.829L13.1323 648.727L12.8269 648.422L12.1143 648.219V647.812Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_150"
        d="M11.2999 639.072L11.0963 639.173L10.9945 638.665L11.1981 638.767L11.2999 639.072Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_151"
        d="M15.7789 631.449L15.2699 631.754H15.0663L14.9645 631.653L15.2699 631.145L15.5753 631.246L15.7789 631.449Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_152"
        d="M1.42527 611.834L1.32347 611.936L1.01807 611.834L1.11987 611.631H1.42527V611.834Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_153"
        d="M654.37 439.26L654.167 439.768L653.861 440.175L653.658 440.277L653.556 440.683L653.76 441.293L653.556 441.395V442.106L653.76 442.411L653.963 442.614L653.76 442.817L653.658 443.122V443.834L653.454 443.935L653.047 444.139L652.538 444.24H652.233L651.724 444.342L651.215 444.24L650.807 444.342L650.502 444.24L649.993 444.444L649.586 444.24H648.975L648.67 444.444L648.364 444.342L648.873 444.139L649.179 443.834L649.586 443.732L649.993 443.427L650.197 443.122L650.807 443.224L651.113 442.817L650.909 442.004L651.113 441.598V441.09V440.886L650.807 440.48L650.502 440.378L650.095 440.277L649.993 440.175L650.4 439.87L651.52 439.768L651.724 439.565H652.843L652.945 439.464L654.167 439.26H654.37Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_154"
        d="M656.814 436.008L656.712 436.516L656.406 436.618L655.999 436.923H655.796L655.083 437.329L654.879 437.126L655.185 436.821L655.897 436.313L656.814 436.008Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="VC"
        d="M653.76 424.219L653.658 424.32L653.149 424.016V423.609L653.352 423.304L653.556 422.796H653.963L654.065 423.202L653.963 424.016L653.76 424.219Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="VG"
        d="M637.37 389.663L636.962 389.867H636.861L636.555 390.07L636.453 389.968L636.555 389.663L637.166 389.562L637.37 389.663Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_155"
        d="M635.741 394.135L636.046 394.44L634.927 394.644L634.825 394.135L635.537 393.932L635.741 394.135Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_156"
        d="M636.454 390.273L636.25 390.476H635.741V390.273L636.046 390.171L636.454 390.273Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_157"
        d="M635.028 390.07L635.435 390.375L635.232 390.578L634.926 390.375H634.417L634.621 390.171L635.028 390.07Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_158"
        d="M22.2941 600.959L22.5995 601.061L22.9049 601.163L23.2103 601.366L23.1085 601.671H22.0905L21.7851 601.569L21.4797 601.671L21.2761 601.569L20.8689 601.366L20.5635 601.468L20.2581 601.264L20.0545 601.061L19.4437 600.756L19.5455 600.35L19.9527 600.146H20.3599H20.8689L21.7851 600.553L22.2941 600.655V600.959Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_159"
        d="M17.7131 598.114L18.3239 598.724L18.5275 599.435L18.4257 599.74L18.5275 600.045H18.2221L17.9167 599.842L17.6113 600.045L16.6951 600.147L16.3897 599.842L16.1861 599.435L15.9825 599.334L15.6771 599.029L15.1681 598.622L14.9645 598.419V598.216L15.3717 598.317L15.6771 598.216L16.2879 598.012H16.6951L17.2041 597.911H17.5095L17.7131 598.114Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BQBO"
        d="M612.836 431.536H612.632L612.531 431.028L612.632 430.723L612.531 430.418L612.123 430.317L611.818 430.012L611.92 429.707L613.141 430.317L613.04 430.52V430.927L612.836 431.13V431.536Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BQSE"
        d="M645.717 395.964L645.514 396.066V395.863L645.616 395.761L645.717 395.964Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="BQSA"
        d="M644.191 395.051H644.089L644.191 394.847L644.293 394.949L644.191 395.051Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="MQ"
        d="M655.592 413.547V413.751L655.999 413.649L655.796 414.157L655.999 414.36V414.564L656.203 414.767L656.406 415.682L656.101 415.986L655.999 415.58L655.897 415.682L655.287 415.58H654.879L654.676 415.275L655.287 414.767H654.879L654.472 414.36L654.37 413.852L654.167 413.344L654.472 412.938L654.879 413.039L655.388 413.344L655.592 413.547Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_160"
        d="M904.391 328.683L904.086 329.191L903.679 329.699L903.373 329.293H902.966L902.763 329.089L902.966 328.785L903.373 328.886L903.781 328.48L904.086 328.276L904.29 328.378L904.391 328.683Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_161"
        d="M918.236 326.346V326.854L918.439 327.26L918.236 327.972L918.338 328.277L917.93 328.683L917.421 328.886L917.218 329.09L916.607 328.886L916.098 328.378L915.894 327.972V327.362L916.505 326.955L916.607 326.447V326.244L917.218 326.346H917.625L917.93 326.447L918.236 326.346Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_162"
        d="M908.158 327.159H907.954L907.649 326.955L907.445 326.65L907.547 326.244L907.649 325.939H907.954H908.26L908.769 326.345L908.871 326.65L908.362 327.159H908.158Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_163"
        d="M914.368 323.602V323.805L913.757 324.11L913.35 324.618L913.044 324.821V325.228L912.637 325.939L912.535 326.346L912.026 326.956L911.924 327.159H911.721L911.11 327.362L911.008 327.26L910.906 326.854L910.601 326.447L910.499 326.244L910.296 325.939V325.634L909.888 325.025L910.397 324.72L910.703 324.923L911.314 324.72H911.721L912.23 324.516L912.739 324.11V323.907L913.35 323.602H913.961L914.266 323.5L914.368 323.602Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_164"
        d="M924.751 326.447L924.446 326.853L924.039 326.955L923.733 326.853H923.326V326.65H923.631L924.242 326.447L924.649 326.142L924.955 325.837L925.057 325.329L925.158 325.024L925.362 324.516L925.667 324.109L925.973 323.5L926.176 322.686L926.38 322.483L926.787 322.382L927.093 322.686L927.194 323.195L927.093 323.703L926.991 324.211V324.719L926.889 324.821L926.584 325.532L926.278 325.837L925.667 325.939L924.955 326.244L924.751 326.447Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_165"
        d="M904.798 321.874L905.104 321.772L905.307 322.077L905.511 322.585L905.307 322.89L905.409 323.297L904.798 324.313L904.697 324.211L904.595 323.805L904.188 322.89L904.086 322.585L903.984 322.382L904.188 321.975L904.493 321.772L904.798 321.874Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_166"
        d="M929.332 319.841V320.248L929.128 320.756L928.416 321.264L927.907 321.366L927.5 321.874L926.991 321.671V321.569L927.194 321.162V320.756L927.398 320.451L927.703 320.248H928.009L928.314 319.943H928.823L928.925 319.841L929.128 319.333L929.332 319.231L929.536 319.435L929.332 319.841Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_167"
        d="M654.574 406.433H654.269L654.065 406.026L654.167 405.823L654.472 405.518L654.778 405.721L654.879 406.026V406.23L654.574 406.433Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_168"
        d="M652.742 403.79H653.047V403.994V404.095L652.843 404.197V405.01V405.417L652.64 405.62L652.029 405.925V405.721L651.825 405.518L651.724 405.01V404.502L651.622 403.994V403.689L651.825 403.384L652.131 403.282L652.64 403.587L652.742 403.79Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_169"
        d="M654.167 403.384L654.574 403.485L655.083 403.892L653.76 404.197L653.454 404.299L653.047 403.994L653.149 403.384L653.352 403.282L653.251 402.672L653.352 402.469L653.658 402.266L653.963 402.672V403.079L654.167 403.384Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="uk"
        d="M990.107 131.615L984.915 138.222L989.699 137.409H994.891L993.568 142.389L989.19 147.877L994.179 148.182L994.484 148.893L998.76 156.109L1002.02 157.125L1004.97 164.24L1006.39 166.679L1012.4 167.797L1011.79 171.862L1009.35 173.692L1011.28 176.944L1006.8 180.196L1000.18 180.095L991.634 181.924L989.394 180.603L986.035 183.55L981.454 182.839L977.789 185.278L975.244 184.058L982.675 177.452L987.154 176.029L979.418 175.013L978.094 172.472L983.286 170.541L980.741 167.187L981.759 163.122L988.987 163.732L989.801 160.073L986.645 156.312L986.544 156.211L980.741 155.093L979.621 153.467L981.454 150.723L979.927 148.995L977.28 151.942L977.178 145.946L974.938 142.897L976.873 136.596L980.741 131.717L984.406 132.124L990.107 131.615Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="us"
        d="M549.211 197.677L543.001 199.71L538.217 202.251L533.534 204.995L533.025 205.909L538.827 204.588L540.965 206.722L545.648 205.198L550.636 203.064L556.133 200.929L552.978 204.283L555.523 205.096L558.068 207.535L563.259 206.113L568.451 205.604L568.757 207.434L570.284 207.637L571.505 207.84L573.032 210.381L568.248 210.991H568.146L564.379 210.28L559.798 211.499L556.032 212.109L551.247 216.276L548.193 218.614L548.6 219.325L554.199 215.158H554.912L550.127 220.138L547.175 224.61L544.63 228.269L544.019 231.419L543.205 232.944L542.594 234.672L542.696 238.026L543.001 238.534L544.834 238.432L546.462 237.721L547.888 236.908L551.247 233.757L553.079 229.488L552.978 225.525L554.403 222.781L557.05 219.63L559.187 217.394L561.936 215.869L561.529 218.004L563.768 214.853L565.092 214.243L566.822 211.804L570.691 213.125L573.541 215.565L572.727 218.512L571.098 221.459L567.23 224L566.822 225.626H567.84L572.218 222.882L573.847 223.492L573.338 227.252L572.625 229.895L568.858 233.452L566.822 235.688L564.074 238.127L566.822 239.448L569.367 239.855L573.439 238.94L577.206 237.212L580.26 236.298L584.943 234.468L590.847 230.606L590.949 229.997L591.254 228.065L594.003 227.252L597.973 227.557L602.045 228.065L606.728 225.931L607.339 223.39L607.135 222.476L614.058 218.004L616.806 216.886L624.747 216.784H634.214L635.334 215.26L637.064 214.955L639.609 213.938L642.46 210.991L645.717 206.011L651.316 201.234L652.436 202.86L656.203 201.844L657.832 203.673L654.879 212.312L657.119 215.971L657.323 218.105L650.807 221.154L644.699 223.39L638.591 225.321L634.519 229.183L633.196 230.606L631.974 234.062L632.687 237.416L634.825 237.619L635.028 235.281L636.148 236.704L635.13 238.534L631.262 239.55L628.717 239.448L624.441 240.566L622.1 240.871L618.944 241.176L613.854 243.107L622.1 241.888L623.22 243.107L615.177 245.038H611.818L612.225 244.225L610.087 246.055L611.513 246.36L608.968 251.035L603.572 256.015L603.674 254.287L602.554 253.982L601.333 252.356V255.913L602.351 257.031L601.74 259.47L599.297 262.011L594.716 267.194L594.308 266.991L597.261 262.519L595.225 260.08L596.243 254.592L594.308 257.438V261.605L591.051 260.588L594.105 262.621L592.578 268.821L594.003 269.329V271.565L592.985 278.069L588.302 282.846L582.092 284.777L577.613 288.639L574.763 289.046L571.302 291.485L569.978 293.619L562.954 297.888L559.086 301.038L555.523 304.9L553.588 309.474V314.048L554.199 319.637L555.726 324.211L555.217 327.057L556.541 334.577L555.523 339.049L554.912 341.59L552.876 345.554L551.043 346.367L548.397 345.554L547.989 342.708L546.157 341.184L544.121 335.594L542.492 330.614L542.085 328.073L544.121 323.703L543.307 320.146L540.151 314.657L538.217 313.641L532.007 316.69L531.091 316.283L529.055 313.234L526.001 311.608L519.485 312.523L514.803 311.71L510.425 312.218L507.88 313.234L508.491 314.962L507.778 317.605L508.593 318.926L507.371 319.739L505.539 318.824L503.197 320.044L499.227 319.841L495.868 316.385L490.88 317.198L487.215 315.674L483.652 316.182L478.562 317.706L472.352 322.483L466.142 325.329L462.376 328.378L460.441 331.325L459.423 335.899L459.016 338.948L459.627 341.184L457.387 341.387L453.723 339.964L449.752 337.931L448.836 334.882L448.633 330.309L446.189 326.65L445.273 322.788L443.644 318.316L440.387 315.674L435.806 315.877L430.919 320.959L426.847 319.028L424.506 317.097L424.099 313.438L423.284 310.084L420.841 307.238L418.703 305.104L417.38 302.766H407.811L406.996 305.51H402.619H391.625L380.528 300.937L373.402 297.786L374.319 296.465L367.091 297.176L360.677 297.684L360.983 294.432L358.845 290.672L356.605 289.859L356.707 288.029L353.755 287.623L352.533 285.895L347.647 285.285L346.731 284.167L347.545 280.61L345 274.106L344.491 265.06L345.407 263.536L344.084 261.401L342.557 255.913L344.389 250.628L343.473 247.071L347.443 241.684L350.294 236.196L351.414 231.216L357.013 225.118L361.085 219.325L365.157 213.532L369.534 204.893L371.366 199.506L371.774 196.559L373.199 195.238L379.103 197.474L378.085 203.47L380.325 201.742L382.87 196.559L384.499 191.376H398.852H413.817H418.703H434.075H449.04H464.106H479.274H496.377H513.683H524.066L525.39 188.937H527.12L526.204 192.392L527.222 193.408L530.582 193.815L535.264 194.831L539.235 196.762L543.714 195.949L549.211 197.677Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="fr"
        d="M1032.66 188.022L1033.78 188.53L1035.2 188.428L1037.65 190.055L1044.98 191.274L1042.53 195.543L1042.13 200.116L1040.8 201.234L1038.46 200.624L1038.67 202.251L1035 205.808V208.755L1037.44 207.739L1039.28 210.483L1039.17 212.312L1040.7 214.751L1038.97 216.682L1040.5 221.663L1043.35 222.476L1042.84 225.22L1038.26 228.879L1027.87 227.151L1020.34 229.285L1019.73 233.147L1013.72 233.96L1007.82 231.013L1005.89 232.436L996.215 229.488L994.179 227.049L996.927 223.187L997.945 210.381L992.754 203.673L988.987 200.421L981.25 197.982L980.843 193.307L987.46 191.986L995.909 193.612L994.382 186.396L999.167 189.14L1010.77 184.261L1012.3 179.078L1016.57 177.757L1017.39 179.993L1019.63 180.094L1022.07 182.635L1025.63 185.583L1028.18 185.074L1032.66 188.022Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="fr-to-us"
        className="invisible-by-default"
        d="M1001.5 201C915.167 189.833 711.8 184.7 589 253.5"
        stroke="#1D1D28"
        strokeWidth="3"
        strokeDasharray="6 10"
      />
      <path
        id="uk-to-bg"
        className="invisible-by-default"
        d="M669 468C701 401.333 810.2 248.4 991 170"
        stroke="#1D1D28"
        strokeWidth="3"
        strokeDasharray="6 10"
      />
      <path
        id="uk-to-fr"
        className="invisible-by-default"
        d="M1005 193C1003.81 188.302 996.738 168.025 990 162.5"
        stroke="#1D1D28"
        strokeWidth="3"
        strokeDasharray="3 3"
      />
      <path
        id="bg"
        d="M674.832 471.072L673.814 476.967L670.251 478.593L670.557 480.117L669.437 483.573L671.88 488.248H673.713L674.425 491.907L677.785 497.598L676.461 497.903L673.204 497.293L671.371 499.021L668.724 500.139L666.892 500.444L666.281 501.765L663.431 501.46L659.868 498.411L659.562 495.362L658.137 492.008L659.155 486.52L660.784 484.183L659.562 481.134L657.526 480.219L658.341 477.272L657.119 475.849L654.065 476.052L650.299 471.174L651.927 469.344V466.295L655.49 465.279L656.916 464.059L655.083 461.62L655.592 459.282L660.377 455.42L664.042 457.86L667.401 462.027L667.503 465.482L669.641 465.584L672.695 468.734L674.832 471.072Z"
        fill="#1D1D28"
        stroke="#6C7099"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </>
));

export const AnimatedMap: React.FC<{
  highlighSvgIds: string[];
  semiHighlighSvgIds: string[];
}> = React.memo((props) => {
  const css = useMemo(
    () => ({
      path: {
        transition: '0.5s opacity ease',
        opacity: 0.1,
        '&.invisible-by-default': {
          opacity: 0,
        },
        ...props.highlighSvgIds.reduce(
          (acc, id) => ({
            ...acc,
            [`&#${id}`]: {
              opacity: 1,
            },
          }),
          {},
        ),
        ...props.semiHighlighSvgIds.reduce(
          (acc, id) => ({
            ...acc,
            [`&#${id}`]: {
              opacity: 0.5,
            },
          }),
          {},
        ),
      },
    }),
    [props.semiHighlighSvgIds, props.highlighSvgIds],
  );

  return (
    <Box
      as="svg"
      width="100%"
      css={css}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 2036 871"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <SVG />
    </Box>
  );
});
